import { Injectable }                               from '@angular/core';
//**************************************************************
import { Observable, Subject }                      from 'rxjs';
import { map }                                      from "rxjs/operators";
import { formatDate }                               from '@angular/common';
import { DatePipe }                                 from '@angular/common';
//**************************************************************
//import { firestore }                                from 'firebase';
import { writeBatch, doc, collection, query, where,
        getDocs }                                   from "firebase/firestore";

import { AngularFirestore }                         from '@angular/fire/compat/firestore';
import { AngularFirestoreCollection }               from '@angular/fire/compat/firestore';
import { AngularFirestoreDocument }                 from '@angular/fire/compat/firestore';
import { AngularFireStorage }                       from '@angular/fire/compat/storage';

import { increment }                                from '@angular/fire/firestore';

//**************************************************************
// Field Definitions
import {  logindetails,
          eventfield,
          participantfield,
          participantcommonfield,
          whoseguestinit,
          inviteefield,
          googleaddress,
          listinvitation,
          giftList,
          listtableseating,
          gantttask,
          dependency,
          scheduler,
          collaboratordetail,
          inviteedashboard,
          financedashboard,
          financecategory,
          financecategorylist,
          appointmentdashboard,
          ganttdashboard,
          gifthankyou,
          dashboardinviteelist,
          faqcategory,
          faqdetail

        }  from '../appfirestore/app.fields';
//**************************************************************
// Functions
import { appfunctions  }                            from '../functions/app.functions';
//import { FieldValue }                               from 'firebase-admin/firestore';
//**************************************************************
@Injectable()
//**************************************************************
export class firestorecontrol
  {
        //**************************************************************
        // Database Collections
        admincollectionName:                          string = 'admin';
        eventcollectionName:                          string = 'event';
        eventparticipantcollectionName:               string = 'eventparticipant';
        eventparticipantcommoncollectionName:         string = 'eventparticipantcommon';
        eventinviteecollectionName:                   string = 'eventinvitee';
        eventgooglecollectionName:                    string = 'googleaddress';
        eventinvitationcollectionName:                string = 'eventinvitationlist';
        eventgiftlistcollectionName:                  string = 'eventgiftlist';
        eventtableseatcollectionName:                 string = 'eventtableseatlist';
        eventtaskganttcollectionName:                 string = 'eventtaskgantt';
        eventtaskganttdependencycollectionName:       string = 'eventtaskganttdependency';
        eventschedulercollectionName:                 string = 'eventscheduler';
        eventcollaboratorcollectionName:              string = 'eventcollaborator';
        eventdashboardcollectionName:                 string = 'eventdashboard';

        faqcollectionName:                            string = 'faq';
        faqnotecollectionName:                        string = 'faqnote';
        //**************************************************************
        // Firestore Collection
        // Name-Event
        eventCollection: AngularFirestoreCollection<eventfield>;  
        eventCRUDCollection: AngularFirestoreCollection<eventfield>; 
        eventDetail: AngularFirestoreDocument<eventfield>;
        eventItems: Observable<eventfield[]>;

        // Name -Event_XXXXXXXXXX
        // Name- eventparticipant
        eventparticipantCollection: AngularFirestoreCollection<participantfield>;  
        eventparticipantCRUDCollection: AngularFirestoreCollection<participantfield>; 
        eventparticipantDetail: AngularFirestoreDocument<participantfield>;
        eventparticipantItems: Observable<participantfield[]>;
      
        // Name- eventparticipantcommon
        eventparticipantCommonCollection: AngularFirestoreCollection<participantcommonfield>;  
        eventparticipantCommonCRUDCollection: AngularFirestoreCollection<participantcommonfield>; 
        eventparticipantCommonDetail: AngularFirestoreDocument<participantcommonfield>;
        eventparticipantCommonItems: Observable<participantcommonfield[]>;

        // Name- EventInvitee -> InviteeList
        eventinviteeCollection: AngularFirestoreCollection<inviteefield>;  
        eventinviteeCRUDCollection: AngularFirestoreCollection<inviteefield>; 
        eventinviteeDetail: AngularFirestoreDocument<inviteefield>;
        eventinviteeItems: Observable<inviteefield[]>;
        eventinviteeNotComingItems: Observable<inviteefield[]>;
        eventinviteeUndecidedItems: Observable<inviteefield[]>;
        eventinviteeConfirmItems: Observable<inviteefield[]>;
        eventinviteeConfirmButNoTable: Observable<inviteefield[]>;
        eventinviteeNoThankyouGiftItems: Observable<inviteefield[]>;

        eventinviteeNoInviteCollection: AngularFirestoreCollection<inviteefield>; 
        eventinviteeNoInviteItems: Observable<inviteefield[]>;
        eventparticipantDashboardItems: Observable<inviteefield[]>;

        // Name- googleaddress 
        eventgoogleCollection: AngularFirestoreCollection<googleaddress>;  
        eventgoogleCRUDCollection: AngularFirestoreCollection<googleaddress>; 
        eventgoogleDetail: AngularFirestoreDocument<googleaddress>;
        eventgoogleItems: Observable<googleaddress[]>;

        // Name- invitationlist 
        eventinvitationlistCollection: AngularFirestoreCollection<listinvitation>;  
        eventinvitationlistCRUDCollection: AngularFirestoreCollection<listinvitation>; 
        eventinvitationlistDetail: AngularFirestoreDocument<listinvitation>;
        eventinvitationlistItems: Observable<listinvitation[]>;

        // Name- giftlist 
        eventgiftlistCollection: AngularFirestoreCollection<giftList>;  
        eventgiftlistCRUDCollection: AngularFirestoreCollection<giftList>; 
        eventgiftlistDetail: AngularFirestoreDocument<giftList>;
        eventgiftlistItems: Observable<giftList[]>;

        // Name- giftthankyou
        eventgiftthankyouCollection: AngularFirestoreCollection<gifthankyou>;  
        eventgiftthankyouCRUDCollection: AngularFirestoreCollection<gifthankyou>; 
        eventgiftthankyouDetail: AngularFirestoreDocument<gifthankyou>;
        eventgiftthankyouItems: Observable<gifthankyou[]>;

        // Name- tableseat 
        eventtableseatlistCollection: AngularFirestoreCollection<listtableseating>;  
        eventtableseatlistCRUDCollection: AngularFirestoreCollection<listtableseating>; 
        eventtableseatlistDetail: AngularFirestoreDocument<listtableseating>;
        eventtableseatlistItems: Observable<listtableseating[]>;

        // Name- taskgantt
        eventtaskganttCollection: AngularFirestoreCollection<gantttask>;  
        eventtaskganttCRUDCollection: AngularFirestoreCollection<gantttask>; 
        eventtaskganttlistDetail: AngularFirestoreDocument<gantttask>;
        eventtaskganttlistItems: Observable<gantttask[]>;

         // Name- taskganttdependency
         eventtaskganttdependencyCollection: AngularFirestoreCollection<dependency>;  
         eventtaskganttdependencyCRUDCollection: AngularFirestoreCollection<dependency>; 
         eventtaskganttdependencylistDetail: AngularFirestoreDocument<dependency>;
         eventtaskganttdependencylistItems: Observable<dependency[]>;

         // Name- taskganttdependency
         eventschedulerCollection: AngularFirestoreCollection<scheduler>;  
         eventschedulerCRUDCollection: AngularFirestoreCollection<scheduler>; 
         eventschedulerlistDetail: AngularFirestoreDocument<scheduler>;
         eventschedulerlistItems: Observable<scheduler[]>;

         // Name- eventcollaborator
         eventcollaboratorCollection: AngularFirestoreCollection<collaboratordetail>;  
         eventcollaboratorCRUDCollection: AngularFirestoreCollection<collaboratordetail>; 
         eventcollaboratorlistDetail: AngularFirestoreDocument<collaboratordetail>;
         eventcollaboratorItems: Observable<collaboratordetail[]>;

         // Name- eventinviteedashboard
         eventinviteedashboardCollection: AngularFirestoreCollection<inviteedashboard>;  
         eventinviteedashboardCRUDCollection: AngularFirestoreCollection<inviteedashboard>; 
         eventinviteedashboardlistDetail: AngularFirestoreDocument<inviteedashboard>;
         eventinviteedashboardItems: Observable<inviteedashboard[]>;

        // Name- eventfinancedashboard
        eventfinancedashboardCollection: AngularFirestoreCollection<financedashboard>;  
        eventfinancedashboardCRUDCollection: AngularFirestoreCollection<financedashboard>; 
        eventfinancedashboardlistDetail: AngularFirestoreDocument<financedashboard>;
        eventfinancedashboardItems: Observable<financedashboard[]>;

        // Name- eventfinancecategory
        eventfinancecategorydashboardCollection: AngularFirestoreCollection<financecategory>;  
        eventfinancecategorydashboardCRUDCollection: AngularFirestoreCollection<financecategory>; 
        eventfinancecategorydashboardlistDetail: AngularFirestoreDocument<financecategory>;
        eventfinancecategorydashboardItems: Observable<financecategory[]>;

        // Name- Finance Category Lisyt
        eventfinancecategoryCollection: AngularFirestoreCollection<financecategorylist>;  
        eventfinancecategoryCRUDCollection: AngularFirestoreCollection<financecategorylist>; 
        eventfinancecategorylistDetail: AngularFirestoreDocument<financecategorylist>;
        eventfinancecategoryItems: Observable<financecategorylist[]>;

        // Name- eventappointmentdashboard
        eventappointmentdashboardCollection: AngularFirestoreCollection<appointmentdashboard>;  
        eventappointmentdashboardCRUDCollection: AngularFirestoreCollection<appointmentdashboard>; 
        eventappointmentdashboardlistDetail: AngularFirestoreDocument<appointmentdashboard>;
        eventappointmentdashboardItems: Observable<appointmentdashboard[]>;

        // Name- eventganttdashboard
        eventganttdashboardCollection: AngularFirestoreCollection<ganttdashboard>;  
        eventganttdashboardCRUDCollection: AngularFirestoreCollection<ganttdashboard>; 
        eventganttdashboardlistDetail: AngularFirestoreDocument<ganttdashboard>;
        eventganttdashboardItems: Observable<ganttdashboard[]>;

        // FAQ
        adminfaqcatDocCollection: AngularFirestoreCollection<faqcategory>; 
        adminfaqcatDocCRUDCollection: AngularFirestoreCollection<faqcategory>;
        adminfaqcatDocItems: Observable<faqcategory[]>;

        faqDocCollection: AngularFirestoreCollection<faqdetail>; 
        faqDocCRUDCollection: AngularFirestoreCollection<faqdetail>; 
        faqDocItems: Observable<faqdetail[]>;
        //**************************************************************
        loginprofile: Array<logindetails> = []; // Empty Array
        //**************************************************************
        whoseguest: Array<whoseguestinit> = []; // Empty Array
        whoseguestinit: Array<string> = []; // Empty Array

        invitedeliverylist: Array<string> = []; // Empty Array

        giftlist: Array<string> = []; // Empty Array
        //**************************************************************
        constructor (    
                       public db: AngularFirestore,
                       private appfunction: appfunctions,
                       private datePipe: DatePipe
                    )
            {

            }
        //**************************************************************        
        async isSignInValid( selcollectionid: string, selpassword: string )
            {

                const pathdataDest = this.eventcollectionName;

                let qry1 = await this.db.collection(pathdataDest).ref.where( 'email','==', selcollectionid )
                                                                             .where( 'password', '==', selpassword).get();
                // Create Empty Array
                this.loginprofile = []

                if ( qry1.size == 1 )      
                  {
                      
                    qry1.forEach  ( doc =>
                                    {
                                        this.loginprofile.push(   {
                                                                    recsize: qry1.size,
                                                                    eventid: doc.get('eventid'),
                                                                    stripestatus: doc.get('stripestatus')                                  
                                                                  }
                                                              );

                                    }
                                  );

                    return this.loginprofile;  
                                     
                  }                                                       
                else
                  {

                    this.loginprofile.push(   {
                                                recsize: qry1.size,
                                                eventid: 'TBC',
                                                stripestatus: false          
                                              }
                                          );

                    return this.loginprofile;                            
        
                    
                  }
            }
            //**************************************************************
            // Update Password
            // Update owner password after reset
            async updateeventpassword
              (   
                  eventid: any,
                  password: string
              ) 
                {

                    var successORFail: number;
                    
                    this.eventCRUDCollection =  this.db.collection( this.eventcollectionName );

                    return successORFail = await this.eventCRUDCollection.doc(eventid).update       
                        (
                            {
                              password: password
                            }
                        ).then( () =>  {
                          return  1;
                        }
                            )
                        .catch ( () =>
                                    { 
                                      return 0;
                                      //console.log( error)
                                    }
                            )    
                  
                      
                }
            //**************************************************************
            // Register a New Event
            // Register Dashboard for Global Parameters
            async addNewEvent( eventid: string,
                               eventname: string,
                               email: string,
                               password: string,
                               stripestatus: boolean,
                               token: string )
                {
                  var successORFail: number;
                  var eventregisterdate  = new Date;

                  // Collection-> Event - Controls all Event Participants that are using the Application to Plan the Event
                  this.eventCRUDCollection =  this.db.collection( this.eventcollectionName );

                  return successORFail = await this.eventCRUDCollection.doc( eventid ).set
                    (
                        {
                          eventid: eventid,
                          eventname: eventname,
                          email: email, 
                          password: password,
                          eventregisterdate: eventregisterdate,
                          stripestatus: stripestatus,
                          token: token
                        },
                        { merge: true }
                    ).then( () =>  {
                                      //-------------------------------------------------------------- 
                                      // Create Common Event Parameters
                                      this.addUpdateCommonProfile (  eventid, 
                                                                    '100',            
                                                                    'TBC',
                                                                    'TBC',
                                                                    'TBC',
                                                                    'TBC' 
                                                                  );
                                      //-------------------------------------------------------------- 
                                      // Create Global Dashboard Parameters
                                      // Invitee Statistics  
                                      this.addDashboardInviteeStats( eventid, 'total');
                                      //--------------------------------------------------------------
                                      // Finance Statistics
                                      this.addDashboardFinanceStats( eventid, 'total');
                                      //--------------------------------------------------------------
                                      // Appointment Statistics
                                      this.addDashboardAppointmentStats( eventid, 'appointmentall');
                                      this.addDashboardAppointmentStats( eventid, 'appointment30');   // 30 days
                                      this.addDashboardAppointmentStats( eventid, 'appointment90');   // 31+ 90days
                                      this.addDashboardAppointmentStats( eventid, 'appointmentrest'); // beyond 90days
                                      //--------------------------------------------------------------
                                      // Task-Gantt Statistics
                                      this.addDashboardGanttStats( eventid, 'tasktotal');         // Total Task
                                      this.addDashboardGanttStats( eventid, 'taskcomplete');      // Task Complete
                                      this.addDashboardGanttStats( eventid, 'tasknotcompletebefore');   // Task not complete with enddate < repdate
                                      this.addDashboardGanttStats( eventid, 'tasknotcompleteafter');    // Task not complete with enddate > repdate
                                      //--------------------------------------------------------------

                                      return  +eventid;
                                    }
                                        )
                                    .catch ( () =>
                                                { 
                                                  return 0;
                                                }
                                        )    
                }
            //**************************************************************
            // Collection - eventparticipant
            // Load Collection - Observable
            //--------------------------------------------------------------
            loadeventparticipant( eventid: string )
              {
                const event = 'event_' + eventid; 

                this.eventparticipantCollection = this.db.collection( event ).doc( this.eventparticipantcollectionName ).collection('list');

                this.eventparticipantItems = this.eventparticipantCollection.snapshotChanges().pipe
                  ( map ( changes => 
                                      {
                                        return changes.map( 
                                                            a => {
                                                                    const data  = a.payload.doc.data() as participantfield;        
                                                                    data.id     = a.payload.doc.id;
                                                                    return data;    
                                                                }                            
                                                          )
                                        }
                          )   
                  )

              }
            //--------------------------------------------------------------
            // Account Profile       
            geteventparticipant()
              {
                  return this.eventparticipantItems;     
              }      
            //--------------------------------------------------------------
            async crudinserteventparticipant( eventid: string, change: any )
              {
                var successORFail: number;

                const event = 'event_' + eventid; 
                //--------------------------------------------------------------
                this.eventparticipantCRUDCollection = this.db.collection( event ).doc( this.eventparticipantcollectionName ).collection('list');
                
                return successORFail = await this.eventparticipantCRUDCollection.doc( change.id ).set
                  (
                        {
                          id:               change.id,
                          firstname:        change.firstname,
                          lastname:         change.lastname,
                          identity:         change.identity,
                          noguestinvite:    change.noguestinvite,
                          budgetamount:     change.budgetamount,
                          triggerrefresh:   ''
                        },
                        { merge: true }
                    ).then( 
                            () =>  {
                                      // Event Participant - Invitee Dashboard Statistics
                                      this.addDashboardInviteeStats( eventid, change.id);

                                      // Event Participant - Finance Dashboard Statistics
                                      this.addDashboardFinanceStats( eventid, change.id);
                              
                                      return  1;
                                    }
                          ).catch ( () =>
                                          { 
                                            return 0;
                                          }
                                  )    
                //--------------------------------------------------------------
                // Create Participants Statistics
                

                //--------------------------------------------------------------                          
              }
            //--------------------------------------------------------------
            async crudupdateeventparticipant( eventid: string, change: any )
              {
                var successORFail: number;

                const event = 'event_' + eventid; 

                // console.log( event )
                //  console.log( change)
               
                this.eventparticipantCRUDCollection = this.db.collection( event ).doc( this.eventparticipantcollectionName ).collection('list');

                return successORFail = await this.eventparticipantCRUDCollection.doc( change.id ).update
                  (
                        {
                          firstname:        change.firstname,
                          lastname:         change.lastname,
                          identity:         change.identity,
                          noguestinvite:    change.noguestinvite,
                          budgetamount:     change.budgetamount
                        }
                    ).then( 
                            () =>  {
                                      return  1;
                                    }
                          ).catch ( () =>
                                          { 
                                            return 0;
                                          }
                                  )    
                //--------------------------------------------------------------

              }
            //--------------------------------------------------------------
            async buildwhoseguestdetails(  eventid: string )
                {
                  //--------------------------------------------------------------
                  const event = 'event_' + eventid; 
                  //--------------------------------------------------------------
                  this.whoseguest = [];
                   // let userdoc = this.db.firestore.collection( event ).doc( this.eventparticipantcollectionName ).collection('list').get().
              
                  this.db.firestore.collection( event ).doc( this.eventparticipantcollectionName ).collection('list').get().
                    then(( querySnapshot) => 
                        { 
                           
                            if ( querySnapshot.size > 0 )
                              {

                                  querySnapshot.forEach((doc) =>
                                                            {  
                                                              var organiserid: string;
                                                              var organiserinit: string;
                                                              var organisername: string;

                                                              organiserid         = doc.get('id'); 
                                                              organiserinit       = doc.get('identity');   
                                                              organisername       = doc.get('firstname') + ' ' +  doc.get('lastname');
                                              
                                                               this.whoseguest.push(   {
                                                                                          id:       organiserid,
                                                                                          initial:  organiserinit,
                                                                                          fullname: organisername
                                                                                                                                     
                                                                                        }
                                                                                    )
                                                        
                                                              }
                                                        )

                             //  this.whoseguest.push(   
                             //                           {
                             //                             id:       '9998',
                             //                             initial:  'Both',
                             //                             fullname: '-'
                             //                           }
                             //                       );
                                                    
                             //   this.whoseguest.push(   
                             //                           {
                              //                            id:       '9999',
                              //                            initial:  'None',
                               //                           fullname: '-'
                               //                         }
                               //                     )  

                              }
                        }
                        
                    ).then 
                        {
                        //  this.whoseguest
                         // console.log(   this.whoseguest )

                         // return this.whoseguest
      
                        }

             
                
              }


             
            geteventparticipantdetails()
              {
                  return this.whoseguest;
              }  
             //-------------------------------------------------------------- 
            async buildwhoseguestinit(  eventid: string )
              {
                // Hannah
                const event = 'event_' + eventid; 
                //**************************************************************
                this.whoseguestinit = [];
              
                this.db.firestore.collection( event ).doc( this.eventparticipantcollectionName ).collection('list').get().
                then(( querySnapshot) => 
                          { 
                            
                              if ( querySnapshot.size > 0 )
                                {
                                    // Register User
                                    querySnapshot.forEach((doc) =>
                                                              {  
                                                            
                                                                var organiserinit: string;
                                                                organiserinit        = doc.get('identity');     
                                                
                                                                this.whoseguestinit.push(   
                                                                                            organiserinit
                                                                                        )
                                                                }
                                                          )

                              //    this.whoseguestinit.push(   
                              //                                'Both'
                              //                            );
                                                      
                              //    this.whoseguestinit.push(   
                              //                              'None'
                              //                            )  

                                }
                          }
                          
                      )
              
            }

            geteventparticipantinit()
              {
                  return this.whoseguestinit;
              }     
            //--------------------------------------------------------------
            async cnteventparticipants(  eventid: string ): Promise<number>
              {
                const event  = 'event_' + eventid; 
  
                let qry1 = await this.db.collection(event).doc( this.eventparticipantcollectionName ).collection('list').ref.get();

                return qry1.size

              }
            //**************************************************************
            // Collection - eventparticipantcommon
            // Load Collection - Observable
            //--------------------------------------------------------------
            loadeventparticipantcommon( eventid: string )
              {
                const event = 'event_' + eventid; 

                this.eventparticipantCommonCollection = this.db.collection( event ).doc( this.eventparticipantcommoncollectionName ).collection('commonprofile');

                this.eventparticipantCommonItems = this.eventparticipantCommonCollection.snapshotChanges().pipe
                  ( map ( changes => 
                                      {
                                        return changes.map( 
                                                            a => {
                                                                    const data  = a.payload.doc.data() as participantcommonfield;        
                                                                    data.id     = a.payload.doc.id;
                                                                    return data;    
                                                                }                            
                                                          )
                                        }
                          )   
                  )

              }
            //--------------------------------------------------------------
            // Account Profile       
            geteventparticipantcommon()
              {
                  return this.eventparticipantCommonItems;     
              }      
            //--------------------------------------------------------------
            async addUpdateCommonProfile( eventid: string,
                                          id : string,
                                          eventtype: string,
                                          eventlocation: string,
                                          eventdatestring: string,
                                          eventrsvpdatestring: string    
               )
                {
                  var successORFail: number;
                  var eventdate: Date = new Date // current system date

                  const event = 'event_' + eventid; 

                  this.eventparticipantCommonCRUDCollection = this.db.collection( event ).doc( this.eventparticipantcommoncollectionName ).collection('commonprofile');

                  return successORFail = await this.eventparticipantCommonCRUDCollection.doc( id ).set
                    (
                        {
                          id: id,
                          eventtype: eventtype,
                          eventlocation: eventlocation,

                          eventdate: eventdate,                   // event date
                          eventdatestring: eventdatestring,

                          eventrsvpdate: eventdate,               // event rsvp
                          eventrsvpdatestring: eventdatestring
                        },
                        { merge: true }
                    ).then( 
                            () =>  {
                                      return  1;
                                    }
                          ).catch ( () =>
                                          { 
                                            return 0;
                                          }
                                  )    
                }
            //**************************************************************
            async commitbatchupdate(  collectionpath: string,
                                      eventid: string,
                                      id : string,
                                      selfield: string,
                                      seldata: any
                              )
              {
                const event = 'event_' + eventid; 

                const pathdataDest = event + collectionpath; 

                const pathdest= this.db.collection( pathdataDest ).doc(id).ref;      

                const batch = this.db.firestore.batch();
                  
                // Create Batch Instructions
                batch.update( pathdest, selfield, seldata );
                //--------------------------------------------------------------
                // Exceptions
                // Field - Event Date
                switch ( selfield )
                  {

                    case 'eventrsvpdate': 
                      {
                        let eventdateformat  = formatDate( seldata, 'yyyy-MM-ddTHH:mm:ss', 'en' );
                        batch.update( pathdest, 'eventrsvpdatestring', eventdateformat );
                        break;
                      }
                
                    case 'eventdate': 
                      {
                        let eventdateformat  = formatDate( seldata, 'yyyy-MM-ddTHH:mm:ss', 'en' );
                        batch.update( pathdest, 'eventdatestring', eventdateformat );
                        break;
                      }

                  }
                //--------------------------------------------------------------
                // Commit change
                return batch.commit().then( () => {
          
              
                                                  }
                                          );             

              }
            //--------------------------------------------------------------
            async commitIncDecbatchupdate(  collectionpath: string,
                                            eventid: string,
                                            id : string,
                                            selfield: string,
                                            seldata: any
                                          )
              {
                  const event = 'event_' + eventid; 

                  const pathdataDest = event + collectionpath; 
                 

                  const pathdest= this.db.collection( pathdataDest ).doc(id).ref  

                  const batch = this.db.firestore.batch();

                  const fldtarget = selfield;

                  batch.update( pathdest, { [fldtarget]: increment( seldata ) });
                  
                  // Commit change
                  return batch.commit().then( () => {
            
                
                                                    }
                                            );             

              }
            //**************************************************************
            // Collection - EventInvitee
            // Load Collection - Observable
            //--------------------------------------------------------------  
            loadeventinvitee( eventid: string )
              {
                const event = 'event_' + eventid; 

                this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist');

                this.eventinviteeItems = this.eventinviteeCollection.snapshotChanges().pipe
                  ( map ( changes => 
                                      {
                                        return changes.map( 
                                                            a => {
                                                                    const data  = a.payload.doc.data() as inviteefield;        
                                                                    data.id     = a.payload.doc.id;
                                                                    return data;    
                                                                }                            
                                                          )
                                        }
                          )   
                  )

              }
          //--------------------------------------------------------------  
          // Invitee List  
          geteventinvitee()
            {
                return this.eventinviteeItems;     
            }      
          //--------------------------------------------------------------
          // Invitee List for Invitee that has not been assign a List for Invitation delivery
          loadeventinvitee_nolist( eventid: string )
            {
              const event = 'event_' + eventid; 

              this.eventinviteeNoInviteCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection( 'inviteelist', ref=>ref.
                                                                                                                            where( 'invitelinkid' , '==' , '0' )
                                                                                                                        );

              this.eventinviteeNoInviteItems = this.eventinviteeNoInviteCollection.snapshotChanges().pipe
                ( map ( changes => 
                                    {
                                      return changes.map( 
                                                          a => {
                                                                  const data  = a.payload.doc.data() as inviteefield;        
                                                                  data.id     = a.payload.doc.id;
                                                                  return data;    
                                                              }                            
                                                        )
                                      }
                        )   
                )

            }

            geteventinvitee_nolist()
            {
                return this.eventinviteeNoInviteItems;     
            }   
          //--------------------------------------------------------------
          // Add Invitee
          async AddUpdateInvitee( addupdateid: number, eventid: string, invitedata: any, googleaddress: string )
            {
              var successORFail: number;

              const event = 'event_' + eventid; 

              this.eventinviteeCRUDCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist');
              this.eventgoogleCRUDCollection  = this.db.collection( event ).doc( this.eventgooglecollectionName ).collection('address');
              
              switch (  addupdateid )
                {
                  //--------------------------------------------------------------
                  // Add Invitee
                  case 10: {

                              return successORFail = await this.eventinviteeCRUDCollection.doc( invitedata.id ).set
                                (
                                  { 
                                      id: invitedata.id,
                                      title: invitedata.title,
                                      firstname: invitedata.firstname,
                                      lastname: invitedata.lastname,
                              
                                      addressid: '',                      // Link to interface address - id
                                      unitno: '0',
                                      streetno: '',
                                      street: '',
                                      suburb: '',
                                      postcode: '',
                                      state: '',
                                      country: '',

                                      poboxid: '',
                                      pobox: '',                         // equivalent to street
                                      poboxsuburb: '',
                                      poboxpostcode: '',
                                      poboxstate: '',
                                      poboxcountry: '',
                              
                                      phone: '',
                                      mobile: '',
                                      email: '',
                              
                                      table: '0',
                                      seatno: '-1',
                              
                                      diettype:'No Dietary Restriction',
                                      dietary: '',

                                      coming: 0,

                                      invitelinkid: "0",
                                      invitelinkstatus: "0",    // 0 = No Invite delivery address # 1 = Yes Invite delivery address
                                      thankyoulinkid: "0",
                              
                                      whoseparticipant: invitedata.whoseparticipant,

                                      triggerrefresh: ''

                                  },
                                  { merge: true }
                                  
                                ).then( 
                                        () =>  {
                                                  return  1;
                                                }
                                      ).catch ( () =>
                                                      { 
                                                        return 0;
                                                      }
                                              ) 
                                        
                            }
                  //--------------------------------------------------------------
                  // Update - Invitee Name Details
                  case 20: {

                              return successORFail = await this.eventinviteeCRUDCollection.doc( invitedata.id ).update
                              (
                                { 
                                    title: invitedata.title,
                                    firstname: invitedata.firstname,
                                    lastname: invitedata.lastname,
                                    whoseparticipant: invitedata.whoseparticipant
                                }
                                
                              ).then( 
                                      () =>  {
                                                return  1;
                                              }
                                    ).catch ( () =>
                                                    { 
                                                      return 0;
                                                    }
                                            ) 
                          }
                  //-------------------------------------------------------------- 
                  // Update Address Details
                  case 30: {
                             
                              //--------------------------------------------------------------
                              // Save Valid Google Address if there NO existing google address
                              let addresssplit = googleaddress.split("#");
                            
                              this.db.firestore.collection( event ).doc( this.eventgooglecollectionName ).collection('address').where('googleaddress','==',addresssplit[0]).get().then(( querySnapshot) => 
                                                                            { 
                                                                              
                                                                                if ( querySnapshot.size == 0 )
                                                                                  {
                                                                                     console.log( addresssplit[0] + '-' + addresssplit[1] )

                                                                                     let addressid = this.appfunction.createuniqueid(6)

                                                                                     this.eventgoogleCRUDCollection.doc( addressid ).set
                                                                                     (
                                                                                       { 
                                                                                            id: addressid,
                                                                                            googleaddress: addresssplit[0],
                                                                                            number: invitedata.unitno,
                                                                                            streetno: invitedata.streetno,
                                                                                            street: invitedata.street,
                                                                                            suburb: invitedata.suburb,
                                                                                            postcode: invitedata.postcode,
                                                                                            state: invitedata.state,
                                                                                            country: addresssplit[1],
                                                                                       },
                                                                                       { merge: true }
                                                                                       
                                                                                     )
                                                                                  }
                                                                                else  
                                                                                  {
                                                                                    console.log('existing')
                                                                                  }

                                                                            }
                                  

                                                                        )
                              //--------------------------------------------------------------                                              
                              // Save Invitee Address Details
                              var poboxid: string = '';                                              

                              if ( invitedata.pobox.length > 0 && 
                                   invitedata.poboxsuburb.length > 0 && 
                                   invitedata.poboxpostcode.length > 0 && 
                                   invitedata.poboxstate.length > 0
                                 )
                                {
                                  poboxid = invitedata.pobox + ', ' + invitedata.poboxsuburb + ' ' + invitedata.poboxpostcode + ' ' + invitedata.poboxstate
                                }

                              return successORFail = await this.eventinviteeCRUDCollection.doc( invitedata.id ).update
                              (
                                { 
                                  addressid: addresssplit[0],                      // Link to interface address - id
                                  unitno: invitedata.unitno,
                                  streetno: invitedata.streetno,
                                  street: invitedata.street,
                                  suburb: invitedata.suburb,
                                  postcode: invitedata.postcode,
                                  state:  invitedata.state,
                                  country: addresssplit[1],

                                  poboxid: poboxid,
                                  pobox: invitedata.pobox,
                                  poboxsuburb: invitedata.poboxsuburb,
                                  poboxpostcode: invitedata.poboxpostcode,
                                  poboxstate: invitedata.poboxstate,
                                  poboxcountry: addresssplit[1]
                                }
                                
                             ).then( 
                                      () =>  {
                                                return  1;
                                              }
                                    ).catch ( () =>
                                                    { 
                                                      return 0;
                                                    }
                                            )                                               

                              //--------------------------------------------------------------
                              break;
                           }
                  //--------------------------------------------------------------       
                  // Update - Contact Details
                  case 40: {

                              return successORFail = await this.eventinviteeCRUDCollection.doc( invitedata.id ).update
                              (
                                { 
                                  phone: invitedata.phone,
                                  mobile: invitedata.mobile,
                                  email: invitedata.email
                                }
                                
                              ).then( 
                                      () =>  {
                                                return  1;
                                              }
                                    ).catch ( () =>
                                                    { 
                                                      return 0;
                                                    }
                                            ) 

                            }
                  //--------------------------------------------------------------
                   // Update - Diet Details
                   case 50: {

                              return successORFail = await this.eventinviteeCRUDCollection.doc( invitedata.id ).update
                                (
                                  { 
                                    diettype: invitedata.diettype,
                                    dietary: invitedata.dietary
                                  }
                                  
                                ).then( 
                                        () =>  {
                                                  return  1;
                                                }
                                      ).catch ( () =>
                                                      { 
                                                        return 0;
                                                      }
                                              ) 

                  }
              //--------------------------------------------------------------           

              }

              return -1
            }
      //--------------------------------------------------------------
      async buildinviteedeliveryinvite(  eventid: string, fldsearch: string, linkid: string ):Promise<any[]> 
        {
          const event = 'event_' + eventid; 
          var addressid: string;
          var poboxid: string;
          var email: string;
          //**************************************************************
          this.invitedeliverylist = [];
         
          let qry1 = await this.db.collection(event).doc(this.eventinviteecollectionName).collection('inviteelist').ref.where( fldsearch,'==', linkid ).get();
          
          if ( qry1.size == 0 )
            {
              return this.invitedeliverylist
            }
          else
            {
              qry1.forEach  ( doc =>
                                      {
                                        //--------------------------------------------------------------
                                        addressid     = doc.get('addressid');
                                        poboxid       = doc.get('poboxid');
                                        email         = doc.get('email');
                                        //--------------------------------------------------------------
                                        if ( addressid.length > 0 )
                                          {
                                            if ( this.invitedeliverylist.indexOf( addressid) == -1 )
                                          
                                            this.invitedeliverylist.push(  
                                                                          addressid
                                                                        );
                                          }
                                        //--------------------------------------------------------------
                                        if ( poboxid.length > 0 )
                                          {
                                            if ( this.invitedeliverylist.indexOf( poboxid) == -1 )
                                          
                                            this.invitedeliverylist.push(  
                                                                          poboxid
                                                                        );
                                          }
                                        //--------------------------------------------------------------
                                        if ( email.length > 0 )
                                          {
                                            if ( this.invitedeliverylist.indexOf( email) == -1 )
                                          
                                            this.invitedeliverylist.push(  
                                                                          email
                                                                        );
                                          }
                                      //--------------------------------------------------------------

                                      }
                              );

              return this.invitedeliverylist

            }
          
        }
    //--------------------------------------------------------------  
      loadeventinviteeundecided( eventid: string )
        {
          
          const event = 'event_' + eventid; 

          this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist',ref=>ref.
                                                                                                                        where( 'coming' , '==' , 0 )
                                                                                                                      );
        
          this.eventinviteeUndecidedItems = this.eventinviteeCollection.snapshotChanges().pipe
            ( map ( changes => 
                                {
                                  return changes.map( 
                                                      a => {
                                                              const data  = a.payload.doc.data() as inviteefield;        
                                                              data.id     = a.payload.doc.id;
                                                              return data;    
                                                          }                            
                                                    )
                                  }
                    )   
            )

        }

    // Invitee not confirmed 
    geteventinviteeundecided()
      {
          return this.eventinviteeUndecidedItems;     
      }      
    //--------------------------------------------------------------  
    loadeventinviteecoming( eventid: string )
        {
          
          const event = 'event_' + eventid; 

          this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist',ref=>ref.
                                                                                                                        where( 'coming' , '==' , 1 )
                                                                                                                      );
         
          this.eventinviteeConfirmItems = this.eventinviteeCollection.snapshotChanges().pipe
            ( map ( changes => 
                                {
                                  return changes.map( 
                                                      a => {
                                                              const data  = a.payload.doc.data() as inviteefield;        
                                                              data.id     = a.payload.doc.id;
                                                              return data;    
                                                          }                            
                                                    )
                                  }
                    )   
            )

        }

      // Invitee confirmed 
      geteventinviteeConfirm()
        {
            return this.eventinviteeConfirmItems;     
        }      
      //--------------------------------------------------------------
      loadeventinviteenotcoming( eventid: string )
        {
          
          const event = 'event_' + eventid; 

          this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist',ref=>ref.
                                                                                                                        where( 'coming' , '==' , -1 )
                                                                                                                      );
         
          this.eventinviteeNotComingItems = this.eventinviteeCollection.snapshotChanges().pipe
            ( map ( changes => 
                                {
                                  return changes.map( 
                                                      a => {
                                                              const data  = a.payload.doc.data() as inviteefield;        
                                                              data.id     = a.payload.doc.id;
                                                              return data;    
                                                          }                            
                                                    )
                                  }
                    )   
            )

        }

      // Invitee not coming
      geteventinviteenotcoming()
        {
            return this.eventinviteeNotComingItems;     
        }      
      //-------------------------------------------------------------- 
      // Invitee coming but not assign a Table
      loadeventinviteecomingBUTNOTable( eventid: string )
        {
          
          const event = 'event_' + eventid; 

          this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist',ref=>ref.
                                                                                                                        where( 'coming' , '==' ,   1   ).
                                                                                                                        where( 'table' , "=="  ,   '0' )
                                                                                                                      );
        
          this.eventinviteeConfirmButNoTable = this.eventinviteeCollection.snapshotChanges().pipe
            ( map ( changes => 
                                {
                                  return changes.map( 
                                                      a => {
                                                              const data  = a.payload.doc.data() as inviteefield;        
                                                              data.id     = a.payload.doc.id;
                                                              return data;    
                                                          }                            
                                                    )
                                  }
                    )   
            )

        }

      // Invitee not coming
      geteventinviteecomingBUTNOTable()
        {
            return this.eventinviteeConfirmButNoTable;     
        }     
      //--------------------------------------------------------------
      loadeventinviteenNOthankyoulink( eventid: string )
        {
          const event = 'event_' + eventid; 

          this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist' ,ref=>ref.
                                                                                                                        where( 'thankyoulinkid' , "=="  , '0' )
                                                                                                                      );

          this.eventinviteeNoThankyouGiftItems = this.eventinviteeCollection.snapshotChanges().pipe
            ( map ( changes => 
                                {
                                  return changes.map( 
                                                      a => {
                                                              const data  = a.payload.doc.data() as inviteefield;        
                                                              data.id     = a.payload.doc.id;
                                                              return data;    
                                                          }                            
                                                    )
                                  }
                    )   
            )

        }
      
    // Invitee Thankyou Gift List  
    geteventinviteeNoThankyoulink()
      {
          return this.eventinviteeNoThankyouGiftItems;     
      }      
    //--------------------------------------------------------------
    loadeventinviteedashboard( eventid: string, whatoption: number, whatorgid: string, whatfld1: string, whatsearch1: any  )
      {
        const event = 'event_' + eventid; 
        //--------------------------------------------------------------
        switch ( whatoption )
          {
            //--------------------------------------------------------------
            case 2: // Invited
                {
                  switch (  whatorgid )
                    {
                      case 'total':
                        {
                          this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist');
                          break;
                        }

                      default:
                        {
                          this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                                where( whatfld1 , '==' , whatsearch1 )
                                                                                                                              );
                          break;                                                                                                    

                        }

                    }
                  
                  break;
                }

            case 3:   // Undecided
            case 4:   // Coming
            case 5:   // Not Coming
                {

                  switch (  whatorgid )
                    {
                      case 'total':
                            {
                              this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                              where( whatfld1 , '==' , whatsearch1 )
                            );
                              break;
                            }

                      default:
                        {
                          this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                                where('whoseparticipant','==',whatorgid ).
                                                                                                                                where( whatfld1 , '==' , whatsearch1 )
                                                                                                                              );
                          break;                                                                                                    

                        }
                    }
                 
                 break;
                }
            //--------------------------------------------------------------
            case 20: // Dietary Needs
                {
                  if ( whatorgid == 'total')
                    {
                      this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                                      where( whatfld1 , '!=' , whatsearch1 )
                                                                                                                                  );

                    }
                  else
                    {
                      this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                                    where('whoseparticipant','==', whatorgid ).
                                                                                                                                    where( whatfld1 ,        '!=', whatsearch1 )
                                                                                                                                  );   

                    }

                  break;
                }
            //--------------------------------------------------------------
            case 25: // Invitation - Invitee that are confirmed  coming = 1
                {

                  if ( whatorgid == 'total')
                    {
                      this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                                      where( 'coming' , '>=' , whatsearch1 )
                                                                                                                                  );

                    }
                  else
                    {

                      console.log( 'ashley' + '  ' + whatfld1 + ' ' + whatsearch1 )
                      this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                                    where('whoseparticipant','==', whatorgid ).
                                                                                                                                    where( 'coming' ,        '>=', whatsearch1 )
                                                                                                                                  );   

                    }

                  break;

                }
            //--------------------------------------------------------------
            case 30:  // Invitation - Invitee -> No Invite
            case 35:  // Invitation - Invitee -> Yes Invite
              {

                if ( whatorgid == 'total')
                  {
                   
                    this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                                    where( 'coming', '>=', 0 ).
                                                                                                                                    where( 'invitelinkstatus' , '==' , whatsearch1 )
                                                                                                                                );

                  }
                else
                  {
                    this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                                  where( 'coming',            '>=', 0 ).
                                                                                                                                  where( 'whoseparticipant',  '==', whatorgid ).
                                                                                                                                  where( 'invitelinkstatus' , '==', whatsearch1 )
                                                                                                                                );   

                  }

                break;

              }
            //--------------------------------------------------------------
            case 40: // Invitee that confirmed coming - therefore if there is a event i.e reception. There could be table allocation
              {

                if ( whatorgid == 'total')
                  {
                    this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                                    where( 'coming' , '==' , whatsearch1 )
                                                                                                                                );

                  }
                else
                  {

                 
                    this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                                  where('whoseparticipant','==', whatorgid ).
                                                                                                                                  where( 'coming' ,        '==', whatsearch1 )
                                                                                                                                );   

                  }

                break;
              }
            //--------------------------------------------------------------
            case 45:  // Confirm - NO table & Seat Assignment
              {

                if ( whatorgid == 'total')
                  {

                                                                                                                               
                   
                    this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                                    where( 'coming', '==', 1 ).
                                                                                                                                    where( 'table' , '==' , whatsearch1 )
                                                                                                                                );

                  }
                else
                  {
                    this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                                  where( 'coming',            '==', 1 ).
                                                                                                                                  where( 'whoseparticipant',  '==', whatorgid ).
                                                                                                                                  where( 'table' , '==', whatsearch1 )
                                                                                                                                );   

                  }


                break;
              }
            //--------------------------------------------------------------
            case 50:  // Confirm - YES table & Seat Assignment
            {

              if ( whatorgid == 'total')
                {

                                                                                                                             
                 
                  this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                                  where( 'coming', '==', 1 ).
                                                                                                                                  where( 'table' , '!=' , whatsearch1 )
                                                                                                                              );

                }
              else
                {
                  this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                                where( 'coming',            '==', 1 ).
                                                                                                                                where( 'whoseparticipant',  '==', whatorgid ).
                                                                                                                                where( 'table' , '!=', whatsearch1 )
                                                                                                                              );   

                }

              break;
            }
          //--------------------------------------------------------------
          case 55: // Thankyou - Not Assign & Assign
              {
                if ( whatorgid == 'total')
                  {
                    this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist');
                   
                  }
                else
                  {
                    this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                          where( whatfld1 , '==' , whatsearch1 )
                                                                                                                        );
                                                                                                                   

                  }

                  break;   

                }

          //--------------------------------------------------------------
          case 60: // Thankyou - Not Assign & Assign
              {
                if ( whatorgid == 'total')
                  {
                    this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                                    where( 'thankyoulinkid', '==', whatsearch1 )
                                                                                                                                );

                  }
                else
                  {
                    this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                                  where( 'whoseparticipant',  '==', whatorgid ).
                                                                                                                                  where( 'thankyoulinkid' , '==', whatsearch1 )
                                                                                                                                );   

                  }

              break;
            }    
          //--------------------------------------------------------------
          case 65: // Thankyou - Assign 
            {
              if ( whatorgid == 'total')
                {
                  this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                                  where( 'thankyoulinkid', '!=', whatsearch1 )
                                                                                                                              );

                }
              else
                {
                  this.eventinviteeCollection = this.db.collection( event ).doc( this.eventinviteecollectionName ).collection('inviteelist', ref=>ref.
                                                                                                                                where( 'whoseparticipant',  '==', whatorgid ).
                                                                                                                                where( 'thankyoulinkid' , '!=', whatsearch1 )
                                                                                                                              );   

                }

              break;
            }    
            //--------------------------------------------------------------

          }
        //--------------------------------------------------------------
        this.eventparticipantDashboardItems = this.eventinviteeCollection.snapshotChanges().pipe
          ( map ( changes => 
                              {
                                return changes.map( 
                                                    a => {
                                                            const data  = a.payload.doc.data() as inviteefield;        
                                                            data.id     = a.payload.doc.id;
                                                            return data;    
                                                        }                            
                                                  )
                                }
                  )   
          )

      }
    //--------------------------------------------------------------  
    // Invitee Thankyou Gift List  
    geteventDashboardinvitee()
      {
          return this.eventparticipantDashboardItems;     
      }      
    //**************************************************************
    // Collection - Google Address 
    // Load Collection - Observable
    //--------------------------------------------------------------  
      loadgoogleaddress( eventid: string )
        {
          const event = 'event_' + eventid; 

          this.eventgoogleCollection = this.db.collection( event ).doc( this.eventgooglecollectionName ).collection('address');

          this.eventgoogleItems = this.eventgoogleCollection.snapshotChanges().pipe
            ( map ( changes => 
                                {
                                  return changes.map( 
                                                      a => {
                                                              const data  = a.payload.doc.data() as googleaddress;        
                                                              data.id     = a.payload.doc.id;
                                                              return data;    
                                                          }                            
                                                    )
                                  }
                    )   
            )

        }
    //--------------------------------------------------------------
    // Get Event Google Addresses       
    geteventgoogleaddress()
      {
          return this.eventgoogleItems;     
      }      

    //--------------------------------------------------------------
    //**************************************************************
    // Collection - invitationlist
    // Load Collection - Observable
    //--------------------------------------------------------------  
    async crudeventinvitationcard( eventid: string )
      {
        var successORFail: number;

        const event = 'event_' + eventid; 

        let inviteid    = this.appfunction.createuniqueid(4)
        
        const inviteelist = [];
        inviteelist.push('Invite Id:'+inviteid);

        this.eventinvitationlistCRUDCollection = this.db.collection( event ).doc( this.eventinvitationcollectionName ).collection('invitationlist');

        return successORFail = await this.eventinvitationlistCRUDCollection.doc( inviteid ).set
                  (
                      {
                        id:               inviteid,
                        deliverylist:     '',
                        delivery:         'TBC',
                        inviteename:       inviteelist
                       
                      },
                      { merge: true }
                  ).then( 
                          () =>  {
                                    return  1;
                                  }
                        ).catch ( () =>
                                        { 
                                          return 0;
                                        }
                                )    
      }
    //--------------------------------------------------------------
    loadinvitationcard( eventid: string )
      {
        const event = 'event_' + eventid; 

        this.eventinvitationlistCollection = this.db.collection( event ).doc( this.eventinvitationcollectionName ).collection('invitationlist');

        this.eventinvitationlistItems = this.eventinvitationlistCollection.snapshotChanges().pipe
          ( map ( changes => 
                              {
                                return changes.map( 
                                                    a => {
                                                            const data  = a.payload.doc.data() as listinvitation;        
                                                            data.id     = a.payload.doc.id;
                                                            return data;    
                                                        }                            
                                                  )
                                }
                  )   
          )

      }

    // Get Event Google Addresses       
    geteventinvitationlist()
      {
          return this.eventinvitationlistItems;     
      } 
      
    async cntinvitationinviteecnt(  eventid: string, invitationlistid: string ): Promise<number>
      {
        const event  = 'event_' + eventid;
        
        var inviteelist: string[];
        //var noinvitee: number;

        let noinvitee = this.db.collection( event ).doc( this.eventinvitationcollectionName ).collection('invitationlist').doc(invitationlistid)
            .get().subscribe( ref => {
                                     
                                      if ( ref.exists)
                                          { 
                                            inviteelist = ref.data()['inviteename']
                                            //console.log('cccc'+  noinvitee )
                                          }

                                          return inviteelist.length
                                      }
                             )

                             return inviteelist.length
      
      }

    invitationdelivery(  eventid: string, invitationlistid: string ):Observable<string>
      {
        const event  = 'event_' + eventid;
        var deliveryinvite: string;
        var subject = new Subject<string>();

        this.db.collection( event ).doc( this.eventinvitationcollectionName ).collection('invitationlist').doc(invitationlistid)
            .get().subscribe( ref => {
                                     
                                      if ( ref.exists)
                                          { 
                                            deliveryinvite = ref.data()['delivery']
                                            subject.next(deliveryinvite);
                                          }
                                        
                                         
                                      }
                             )
        return subject.asObservable()
       
      }
    //**************************************************************  
    // Collection - giftlist
    // Load Collection - Observable
    //--------------------------------------------------------------
    loadeventgiftlist( eventid: string )
      {
        const event = 'event_' + eventid; 

        this.eventgiftlistCollection = this.db.collection( event ).doc( this.eventgiftlistcollectionName ).collection('giftlist');

        this.eventgiftlistItems = this.eventgiftlistCollection.snapshotChanges().pipe
          ( map ( changes => 
                              {
                                return changes.map( 
                                                    a => {
                                                            const data  = a.payload.doc.data() as giftList;        
                                                            data.id     = a.payload.doc.id;
                                                            return data;    
                                                        }                            
                                                  )
                                }
                  )   
          )

      }
    //--------------------------------------------------------------
    // Account Profile       
    geteventgiftlist()
      {
          return this.eventgiftlistItems;     
      }      
    //--------------------------------------------------------------  
    async AddUpdateGift( addupdateid: number, eventid: string, invitedata: any )
      {
        var successORFail: number;

        const event = 'event_' + eventid; 
        let giftdetaildesc = invitedata.giftdescription + '#' + invitedata.id

        this.eventgiftlistCRUDCollection = this.db.collection( event ).doc( this.eventgiftlistcollectionName ).collection('giftlist');

        switch (  addupdateid )
          {
            //--------------------------------------------------------------
            // Add Gift Profile
            case 10:  {

                        return successORFail = await this.eventgiftlistCRUDCollection.doc( invitedata.id ).set
                          (
                            { 
                              id: invitedata.id,
                              giftdescription: invitedata.giftdescription,
                              brand: invitedata.brand,
                              sourceoption: invitedata.sourceoption,

                              giftlist: invitedata.giftlist,
                              giftassign: false,                          // giftdescription#id
                              giftdetail: giftdetaildesc, 

                              notes: invitedata.notes,
                              triggerrefresh: ''
                            },
                            { merge: true }
                            
                          ).then( 
                                  () =>  {
                                            return  1;
                                          }
                                ).catch ( () =>
                                                { 
                                                  return 0;
                                                }
                                        );


                        break;
                      }
            //--------------------------------------------------------------
            // Edit Gift Profile
            case 20:  {
                        return successORFail = await this.eventgiftlistCRUDCollection.doc( invitedata.id ).update
                          (
                            { 
                              giftdescription: invitedata.giftdescription,
                              brand: invitedata.brand,
                              sourceoption: invitedata.sourceoption,
                              giftlist: invitedata.giftlist,
                              giftdetail: giftdetaildesc,
                              notes: invitedata.notes
                            }
                            
                          ).then( 
                                  () =>  {
                                            return  1;
                                          }
                                ).catch ( () =>
                                                { 
                                                  return 0;
                                                }
                                        )

                        break;
                      }
            //--------------------------------------------------------------
          }

          return -1
      } 
    //--------------------------------------------------------------
    thankyoudelivery(  eventid: string, thankyoulistid: string ):Observable<string>
      {
        const event  = 'event_' + eventid;
        var deliveryinvite: string;
        var subject = new Subject<string>();

        this.db.collection( event ).doc( this.eventgiftlistcollectionName ).collection('giftthankyou').doc(thankyoulistid)
            .get().subscribe( ref => {
                                     
                                      if ( ref.exists)
                                          { 
                                            deliveryinvite = ref.data()['deliverylist']
                                            subject.next(deliveryinvite);
                                          }
                                        
                                         
                                      }
                             )
        return subject.asObservable()
       
      }
    //--------------------------------------------------------------
    async buildgiftlist (  eventid: string  ):Promise<any[]> 
      {
        const event = 'event_' + eventid;
        var giftdetail: string;
        //**************************************************************
        this.giftlist = [];

        let qry1 = await this.db.collection(event).doc(this.eventgiftlistcollectionName).collection('giftlist').ref.where( 'giftassign','==', false ).get();
            
        if ( qry1.size == 0 )
          {
            return this.giftlist
          }
        else
          {
            qry1.forEach  ( doc =>
                              {
                                //--------------------------------------------------------------
                                giftdetail        = doc.get('giftdetail');
                                
                                this.giftlist.push(  
                                                    giftdetail
                                                  );

                              }
                            )
                              
            return this.giftlist
          }

      }
    //--------------------------------------------------------------
    //**************************************************************
    // Collection - tablelist
    // Load Collection - Observable
    async crudeventtable( eventid: string )
      {
        var successORFail: number;

        const event     = 'event_' + eventid; 

        let tableid     = this.appfunction.createuniqueid(4)
        
        const inviteelist = [];
        inviteelist.push('Table Id:'+tableid);

        this.eventtableseatlistCRUDCollection = this.db.collection( event ).doc( this.eventtableseatcollectionName ).collection('tableseatlist');

        return successORFail = await this.eventtableseatlistCRUDCollection.doc( tableid ).set
                  (
                      {
                        id:               tableid,
                        table:            'Table Name TBC',
                        tableorder:       0,
                        inviteename:      inviteelist
                      },
                      { merge: true }
                  ).then( 
                          () =>  {
                                    return  1;
                                  }
                        ).catch ( () =>
                                        { 
                                          return 0;
                                        }
                                )    
      }
    //--------------------------------------------------------------  
    // Update Table Name and Order
    async crudsettableprofile( eventid: string, seltableid: string, seltablename: string, seltableorder: number )
    {
        var successORFail: number;

        const event     = 'event_' + eventid; 

        this.eventtableseatlistCRUDCollection = this.db.collection( event ).doc( this.eventtableseatcollectionName ).collection('tableseatlist');

        return successORFail = await this.eventtableseatlistCRUDCollection.doc( seltableid ).update
                  (
                      {
                        table:  seltablename,           
                        tableorder: seltableorder      
                      }
                  ).then( 
                          () =>  {
                                    return  1;
                                  }
                        ).catch ( () =>
                                        { 
                                          return 0;
                                        }
                                )    
    }
    //--------------------------------------------------------------
    loadtableseatcard( eventid: string )
      {
        const event = 'event_' + eventid; 

        this.eventtableseatlistCollection = this.db.collection( event ).doc( this.eventtableseatcollectionName ).collection('tableseatlist');

        this.eventtableseatlistItems = this.eventtableseatlistCollection.snapshotChanges().pipe
          ( map ( changes => 
                              {
                                return changes.map( 
                                                    a => {
                                                            const data  = a.payload.doc.data() as listtableseating;        
                                                            data.id     = a.payload.doc.id;
                                                            return data;    
                                                        }                            
                                                  )
                                }
                  )   
          )

      }

    // Get table seat list for invitees
    geteventtableseatlist()
      {
          return this.eventtableseatlistItems;     
      } 
    //--------------------------------------------------------------   
    gettableinviteelist(  eventid: string, pathtableseatlist: string, tableid: string, inviteeid: string )
      {
        var tablelist: string[];
        var listindex: number;
        var listitem: string;

        const event = 'event_' + eventid; 

        this.db.collection( event ).doc( this.eventtableseatcollectionName ).collection('tableseatlist').doc(tableid)
            .get().subscribe( ref => {

                                        if ( ref.exists)
                                          {
                                            tablelist = ref.data()['inviteename']

                                            //console.log( tablelist )
                                            // listindex = tablelist.findIndex((element) => element > inviteeid )
                                            listindex = tablelist.indexOf(inviteeid )
                                            //console.log( listindex )
                                         
                                            if ( listindex != -1 )
                                              {
                                                // Remove invitee from list
                                                tablelist.splice( listindex, 1 );
                                                //console.log( tablelist )

                                                // Firestore -> update Table List
                                                this.commitbatchupdate( 
                                                                        pathtableseatlist, 
                                                                        eventid,
                                                                        tableid,
                                                                        'inviteename', 
                                                                        tablelist
                                                );

                                              }
                                           
                                          }
                                      }

                            )
      }
    //--------------------------------------------------------------
    //**************************************************************
    // Collection - taskgantt
    // Add New Gantt Task
    async addNewGanttTask( eventid: string, selganttid: string, selparentganntid: string, taskprofile: any ) 
      {
        var successORFail: number;
       
        const event     = 'event_' + eventid; 

        // console.log( taskprofile )

        this.eventtaskganttCRUDCollection = this.db.collection( event ).doc( this.eventtaskganttcollectionName ).collection('gantttask');

        return successORFail = await this.eventtaskganttCRUDCollection.doc( selganttid ).set
                  (
                      {
                        id: selganttid,
  
                        parentId: taskprofile.values.parentId,
                        title: taskprofile.values.title,

                        start: taskprofile.values.start,
                        end:taskprofile.values.end,                      

                        progress: taskprofile.values.progress,

                        color: taskprofile.values.color,

                        budget:     0,
                        actual:     0,
                        tasktotal:  0,

                        parenttaskid: selparentganntid,

                        taskconfirm: taskprofile.values.taskconfirm
                      },
                      { merge: true }
                  ).then( 
                          () =>  {
                                    return  1;
                                  }
                        ).catch ( () =>
                                        { 
                                          return 0;
                                        }
                                )    



      }
    //**************************************************************
    // Update Gantt Task details
    async updateGanttTask( eventid: string, taskdetail: any ) 
      {
        var successORFail: number;
        var startdate: string;
        var enddate: string;

        const event = 'event_' + eventid; 

        this.eventtaskganttCRUDCollection = this.db.collection( event ).doc( this.eventtaskganttcollectionName ).collection('gantttask');
        //--------------------------------------------------------------
        startdate = formatDate( taskdetail.start, 'yyyy-MM-ddTHH:mm:ss', 'en' );
        enddate   = formatDate( taskdetail.end,   'yyyy-MM-ddTHH:mm:ss', 'en' );

        return successORFail = await this.eventtaskganttCRUDCollection.doc( taskdetail.id) .update       
              (
                  {
                    title:    taskdetail.title,

                    start:    startdate,
                    end:      enddate,                      

                    progress: taskdetail.progress,

                    budget:   taskdetail.budget,
                    actual:   taskdetail.actual,

                    taskconfirm:   taskdetail.taskconfirm

                  }
              ).then( () => {
                              return  1;
                            }
                  )
                  .catch ( () =>
                              { 
                                return 0;
                              }
                      );    

          }
        //--------------------------------------------------------------
        async deleteGanttTask( eventid: string, ganttid: string ) 
          {
            var successORFail: number;
    
            const event = 'event_' + eventid; 
    
            // Deleting Gantt Task
            this.eventtaskganttCRUDCollection = this.db.collection( event ).doc( this.eventtaskganttcollectionName ).collection('gantttask');
            this.eventtaskganttCRUDCollection.doc( ganttid ).delete();

            // Deleting Gantt Task Dependencies
            this.eventtaskganttdependencyCRUDCollection = this.db.collection( event ).doc( this.eventtaskganttdependencycollectionName ).collection('gantttaskdependency');
            this.eventtaskganttdependencyCRUDCollection.doc( ganttid ).delete();
          }
    //**************************************************************
    async updateGanttTaskStartEndDate( eventid: string, taskid: string, startdate: any, enddate: any ) 
      {
        var successORFail: number;
        var startdate1: string;
        var enddate1: string;

        const event = 'event_' + eventid; 

        this.eventtaskganttCRUDCollection = this.db.collection( event ).doc( this.eventtaskganttcollectionName ).collection('gantttask');
        //--------------------------------------------------------------
        // startdate change only 
        if ( startdate != null && enddate == null )
          {
            //console.log( 'Start')
            startdate1 = formatDate( startdate, 'yyyy-MM-ddTHH:mm:ss', 'en' );

            return successORFail = await this.eventtaskganttCRUDCollection.doc(taskid).update       
              (
                  {
                    start: startdate1
                  }
              ).then( () => {
                              return  1;
                            }
                  )
                  .catch ( () =>
                              { 
                                return 0;
                              }
                      );    

          }
        //--------------------------------------------------------------  
        // enddate change only
        if ( startdate == null && enddate != null )
          {
            //console.log( 'End')

            enddate1 = formatDate( enddate, 'yyyy-MM-ddTHH:mm:ss', 'en' );
            return successORFail = await this.eventtaskganttCRUDCollection.doc(taskid).update       
            (
                {
                  end: enddate1
                }
            ).then( () => {
                            return  1;
                          }
                )
                .catch ( () =>
                            { 
                              return 0;
                            }
                    );    
            
          }
        //--------------------------------------------------------------
        // startdate and enddate change 
        if ( startdate != null && enddate != null )
          {
            // console.log( 'start End')

            startdate1  = formatDate( startdate, 'yyyy-MM-ddTHH:mm:ss', 'en' );
            enddate1    = formatDate( enddate, 'yyyy-MM-ddTHH:mm:ss', 'en' );

            return successORFail = await this.eventtaskganttCRUDCollection.doc(taskid).update       
              (
                  {
                    start: startdate1,
                    end: enddate1
                  }
              ).then( () => {
                              return  1;
                            }
                  )
                  .catch ( () =>
                              { 
                                return 0;
                              }
                      );   
            
          }

          return -1
      }
    //**************************************************************
    // Load Collection - Observable
    loadtaskgantt( eventid: string, filteroption: number, ganttid: string )
      {
        const event = 'event_' + eventid; 

        switch ( filteroption )
          {
            case 1:
                {
                  this.eventtaskganttCollection = this.db.collection( event ).doc( this.eventtaskganttcollectionName ).collection('gantttask');
                  break;
                }

            case 5:
                  {
                    this.eventtaskganttCollection = this.db.collection( event ).doc( this.eventtaskganttcollectionName ).collection('gantttask',ref=>ref
                                                    .where( 'taskconfirm','==', true )
                                                    .orderBy('start','asc') );
                   
                   
                    break;
                  }

            case 10:
                {
                  this.eventtaskganttCollection = this.db.collection( event ).doc( this.eventtaskganttcollectionName ).collection('gantttask',ref=>ref
                  .where( 'taskconfirm','==', true ))
                  break;
                }

            case 15:
                  {
                    this.eventtaskganttCollection = this.db.collection( event ).doc( this.eventtaskganttcollectionName ).collection('gantttask',ref=>ref
                    .where( 'id','==', ganttid ))
                    break;
                  }

            case 20:
                    {
                      this.eventtaskganttCollection = this.db.collection( event ).doc( this.eventtaskganttcollectionName ).collection('gantttask',ref=>ref
                      .where( 'id','in', [ganttid,'8730'] )
                      
                      
                      
                      
                      )
                      break;
                    }
               
          }

        this.eventtaskganttlistItems = this.eventtaskganttCollection.snapshotChanges().pipe
          ( map ( changes => 
                              {
                                return changes.map( 
                                                    a => {
                                                            const data  = a.payload.doc.data() as gantttask;        
                                                            data.id     = a.payload.doc.id;
                                                            return data;    
                                                        }                            
                                                  )
                                }
                  )   
          )

      }
    //--------------------------------------------------------------
    // Gantt Task Profile       
    geteventtaskgantt()
      {
          return this.eventtaskganttlistItems;     
      }      
    //--------------------------------------------------------------  
    //**************************************************************
    // Collection - taskganttdependency
    loadtaskganttdependency( eventid: string )
      {
        const event = 'event_' + eventid; 

        this.eventtaskganttdependencyCollection = this.db.collection( event ).doc( this.eventtaskganttdependencycollectionName ).collection('gantttaskdependency');

        this.eventtaskganttdependencylistItems = this.eventtaskganttdependencyCollection.snapshotChanges().pipe
          ( map ( changes => 
                              {
                                return changes.map( 
                                                    a => {
                                                            const data  = a.payload.doc.data() as dependency;        
                                                            data.id     = a.payload.doc.id;
                                                            return data;    
                                                        }                            
                                                  )
                                }
                  )   
          )

      }
    //--------------------------------------------------------------
    // Gantt Task Profile       
    geteventtaskganttdependency()
      {
          return this.eventtaskganttdependencylistItems;     
      }      
    //--------------------------------------------------------------    
    async addNewGanttTaskDependency( eventid: string, selganttid: string ) 
      {
        var successORFail: number;
      
        const event     = 'event_' + eventid; 

        this.eventtaskganttdependencyCRUDCollection = this.db.collection( event ).doc( this.eventtaskganttdependencycollectionName ).collection('gantttaskdependency');

        return successORFail = await this.eventtaskganttdependencyCRUDCollection.doc( selganttid ).set
                  (
                      {
                        id: selganttid,
                        predecessorId: 0,
                        successorId: 0,
                        type: -1,     
                        typedesc: 'tbc'
                      },
                      { merge: true }
                  ).then( 
                          () =>  {
                                    return  1;
                                  }
                        ).catch ( () =>
                                        { 
                                          return 0;
                                        }
                                )    
      }
    //-------------------------------------------------------------- 
    async updateGanttTaskDependency( eventid: string, taskdependencyprofile: any ) 
      {
        var successORFail: number;
       
        const event     = 'event_' + eventid; 

        this.eventtaskganttdependencyCRUDCollection = this.db.collection( event ).doc( this.eventtaskganttdependencycollectionName ).collection('gantttaskdependency');

        return successORFail = await this.eventtaskganttdependencyCRUDCollection.doc(taskdependencyprofile.values.predecessorId).update       
        (
            {   
              predecessorId: taskdependencyprofile.values.predecessorId,
              successorId: taskdependencyprofile.values.successorId,
              type: taskdependencyprofile.values.type,
              typedesc: this.getdependency( taskdependencyprofile.values.type )
            }
        ).then( () => {
                        return  1;
                      }
            )
            .catch ( () =>
                        { 
                          return 0;
                        }
                );   


      }
    //--------------------------------------------------------------
    async deleteGanttTaskDependency( eventid: string, taskdependencyprofile: any ) 
      {
        var successORFail: number;
       
        const event     = 'event_' + eventid; 

        this.eventtaskganttdependencyCRUDCollection = this.db.collection( event ).doc( this.eventtaskganttdependencycollectionName ).collection('gantttaskdependency');

        return successORFail = await this.eventtaskganttdependencyCRUDCollection.doc(taskdependencyprofile.values.predecessorId).update       
        (
            {   
              predecessorId: 0,
              successorId: 0,
              type: -1,
              typedesc: 'tbc'
            }
        ).then( () => {
                        return  1;
                      }
            )
            .catch ( () =>
                        { 
                          return 0;
                        }
                );   

      }
    //--------------------------------------------------------------
    getdependency( dependencyid: number )
      {
        var dependtype: string;

        switch ( dependencyid )
          {
            case 0: {
                      dependtype = 'FS';
                      break;
                    }

            case 1: {
                      dependtype = 'SS';
                      break;
                    }

            case 2: {
                      dependtype = 'FF';
                      break;
                    }

            case 3: {
                      dependtype = 'SF';
                      break;
                    }

          }

        return dependtype;

      }
    //--------------------------------------------------------------
    async cnttask(  eventid: string, taskid: string, taskparentid: string, tasktopparentid: string ): Promise<number>
      {
        const event  = 'event_' + eventid; 
  
        let qry1 = await this.db.collection(event).doc( this.eventtaskganttcollectionName).collection('gantttask').ref
                                                    .where( 'parentId','==', taskid ).get();

        return qry1.size

      }
    //**************************************************************
    // Collection - scheduler / appointments
    // Load Collection - Observable
    loadscheduler( eventid: string, seltask: number, seloption: number, selparentgantttaskid: string,
                   startdate: Date, endate: Date  )
      {
        const event = 'event_' + eventid; 

        console.log( seloption )
        //--------------------------------------------------------------
        switch ( seltask )
          {
            //--------------------------------------------------------------
            // Gannt Appointmemts 
            case 1:
              {
                switch ( seloption )
                  {
                    // All Schedule Items
                    case 1: {
                              this.eventschedulerCollection = this.db.collection( event ).doc( this.eventschedulercollectionName ).collection('schedulertask');
                              break;
                            }

                    // All Schedule Items ONLY for Gantt TaskParent Id
                    case 10: {
                                this.eventschedulerCollection = this.db.collection( event ).doc( this.eventschedulercollectionName ).collection('schedulertask', ref=>ref.
                                                                where( 'parentgantttaskid' , '==' , selparentgantttaskid )
                                                                                  );
                                break;
                            }

                    // All Schedule Items ONLY selected period
                    case 15: {

                                let startD  = formatDate( startdate, 'yyyy-MM-ddTHH:mm:ss', 'en' );
                                let endD    = formatDate( endate, 'yyyy-MM-ddTHH:mm:ss', 'en' );

                                this.eventschedulerCollection = this.db.collection( event ).doc( this.eventschedulercollectionName ).collection('schedulertask', ref=>ref
                                                                                                .where( 'startDate','>=', startD )
                                                                                                .where( 'startDate', '<=', endD )
                                                                                              );
                                break;
                              }
                  }
                break;
              }
          //--------------------------------------------------------------
          // Scheduler 
          case 100: 
              {

                switch ( seloption )
                 {
                    case -1: {

                            // let startD  = formatDate( startdate, 'yyyy-MM-ddTHH:mm:ss', 'en' );
                            // let endD    = formatDate( endate, 'yyyy-MM-ddTHH:mm:ss', 'en' );

                             

                              this.eventschedulerCollection = this.db.collection( event ).doc( this.eventschedulercollectionName ).collection('schedulertask', ref=>ref
                                                                                              .where( 'edate','<=', endate )
                                                                                            
                                                                                            );
                              break;
                            }

                    case 0: {

                            console.log('dddd:' +  endate )

                              this.eventschedulerCollection = this.db.collection( event ).doc( this.eventschedulercollectionName ).collection('schedulertask', ref=>ref
                                                                                              .where( 'edate','>=', startdate )
                                                                                              .where( 'edate','<=', endate )
                                                                                            );
                              break;
                            }
          
                  }

                break;

              }
          }
        //--------------------------------------------------------------
        this.eventschedulerlistItems = this.eventschedulerCollection.snapshotChanges().pipe
          ( map ( changes => 
                              {
                                return changes.map( 
                                                    a => {
                                                            const data  = a.payload.doc.data() as scheduler;        
                                                            data.id     = a.payload.doc.id;
                                                            return data;    
                                                        }                            
                                                  )
                                }
                  )   
          )

      }
    //--------------------------------------------------------------
    // Gantt Task Profile       
    getscheduler()
      {
          return this.eventschedulerlistItems;     
      }      
    //--------------------------------------------------------------  
    async addNewSchedule( eventid: string, selscheduledata: any,
                          selparentgantttaskid: string, selgantttaskid: string ) 
      {
        var successORFail: number;
        var start: string;
        var end: string;
        var note: string = '';
        var alldaystatus: boolean = false;

        var xxxx: string;
        var yyyy: string;

        console.log( selscheduledata )

        //console.log( selscheduledata )
        //console.log( selparentgantttaskid + ' ' + selgantttaskid )
      
        const event         = 'event_' + eventid; 

        // Create a Appointment Id
        let scheduleid      = this.appfunction.createuniqueid(6)

        start               = formatDate( selscheduledata.startDate, 'yyyy-MM-ddTHH:mm:ss', 'en' );
        end                 = formatDate( selscheduledata.endDate, 'yyyy-MM-ddTHH:mm:ss', 'en' );

        xxxx = this.datePipe.transform( selscheduledata.startDate, "dd-MMM-yy")
        console.log( xxxx )
        console.log( new Date( xxxx ))

        yyyy = this.datePipe.transform( selscheduledata.endDate, "dd-MMM-yy")
        console.log( yyyy )
        console.log( new Date( yyyy ))

        //--------------------------------------------------------------
        if ( selscheduledata.allDay != undefined ) 
          {
            alldaystatus = selscheduledata.allDay  
          }
        //--------------------------------------------------------------
        if ( selscheduledata.description != undefined ) 
          {
            note = selscheduledata.description  
          }
        //--------------------------------------------------------------
        this.eventschedulerCRUDCollection = this.db.collection( event ).doc( this.eventschedulercollectionName ).collection('schedulertask');

        return successORFail = await this.eventschedulerCRUDCollection.doc( scheduleid ).set
                  (
                      {
                        id: scheduleid,
                        title: selscheduledata.title,

                        startDate: start,
                        sdate: new Date( xxxx ),

                        endDate: end,
                        edate: new Date( yyyy ),
                        allDay: alldaystatus,

                        description: note, // Notes

                        parentgantttaskid: selparentgantttaskid,
                        gantttaskid: selgantttaskid,

                        nocollaborator: 0,          // No of collaborators
                        nocollaboratorconfirm: 0       // No of collaborators confirmed
                      },
                      { merge: true }
                  ).then( 
                          () =>  {
                                    return  1;
                                  }
                        ).catch ( () =>
                                        { 
                                          return 0;
                                        }
                                )    
      }
    //-------------------------------------------------------------- 
    async updateSchedule( eventid: string, selscheduledata: any ) 
      {
        var successORFail: number;
        var start: string;
        var end: string;
        var note: string;

        var xxxx: string;
        var yyyy: string;

        const event         = 'event_' + eventid; 

       console.log( selscheduledata )

       xxxx = this.datePipe.transform( new Date( selscheduledata.startDate ), "dd-MMM-yy")
       console.log( xxxx )
       console.log( new Date( xxxx ))

       yyyy = this.datePipe.transform( selscheduledata.endDate, "dd-MMM-yy")
       console.log( yyyy )
       console.log( new Date( yyyy ))

       

       // start               = formatDate( selscheduledata.startDate, 'yyyy-MM-ddTHH:mm:ss', 'en' );
       // end                 = formatDate( selscheduledata.endDate, 'yyyy-MM-ddTHH:mm:ss', 'en' );


        this.eventschedulerCRUDCollection = this.db.collection( event ).doc( this.eventschedulercollectionName ).collection('schedulertask');

        return successORFail = await this.eventschedulerCRUDCollection.doc( selscheduledata.id ).update
        (
          {
            title: selscheduledata.title,

            startDate: selscheduledata.startDate,
            sdate: new Date( xxxx ),

            endDate: selscheduledata.endDate,
            edate: new Date( yyyy ),
            
            allDay: selscheduledata.allDay,

            description: selscheduledata.description // Notes            
          }
        ).then( 
              () =>  {
                        return  1;
                      }
            ).catch ( () =>
                            { 
                              return 0;
                            }
                    )    
        }
    //-------------------------------------------------------------- 
    async deleteSchedule( eventid: string, scheduleid: string ) 
      {
        var successORFail: number;

        const event = 'event_' + eventid; 

        this.eventschedulerCRUDCollection = this.db.collection( event ).doc( this.eventschedulercollectionName ).collection('schedulertask');
        
        this.eventschedulerCRUDCollection.doc( scheduleid ).delete();
      }
    //**************************************************************
    // Collection - eventcollaborator
    // Load Collection - Observable
    //--------------------------------------------------------------
    loadeventcollaborator( eventid: string, whatfilteropotion: number, selganttid: string, eventorganiser: string[] )
      {
        const event = 'event_' + eventid; 
      
        switch ( whatfilteropotion )
          {
            //--------------------------------------------------------------
            // All Collaborators
            case 1:
                {
                  this.eventcollaboratorCollection = this.db.collection( event ).doc( this.eventcollaboratorcollectionName ).collection('collaborator');
                  break;
                }
            //--------------------------------------------------------------
            // All Collaborators - Order by Category
             case 5:
              {
               
                this.eventcollaboratorCollection = this.db.collection( event ).doc( this.eventcollaboratorcollectionName ).collection('collaborator',ref=>ref.orderBy('category','asc') )
                break;
              }
            //--------------------------------------------------------------
            // All Collaborators - By Gantt Task
            case 10:
                {
                  this.eventcollaboratorCollection = this.db.collection( event ).doc( this.eventcollaboratorcollectionName ).collection('collaborator', ref=>ref.
                                                                                                                                          where( 'ganttId' , '==' , selganttid )
                                                                                                                                        );                                         
                  break;
                }
            //--------------------------------------------------------------
            case 20:
                {
                  // eventorganiser = determines no of event organisers
                  if ( eventorganiser.length == 1 )
                    {
                      this.eventcollaboratorCollection = this.db.collection( event ).doc( this.eventcollaboratorcollectionName ).collection('collaborator', ref=>ref.
                                                                                                                                          where( 'sharecostparticipant' , 'array-contains' , eventorganiser[0] )
                                                                                                                                        );
                    }
                  else
                    {
                      switch (  eventorganiser.length )
                        {
                          case 2:
                              {
                                this.eventcollaboratorCollection = this.db.collection( event ).doc( this.eventcollaboratorcollectionName ).collection('collaborator', ref=>ref.
                                                                                                    where( 'sharecostparticipant' , 'array-contains-any' , [ eventorganiser[0], eventorganiser[1] ] )
                                                                                                  );
                                break;
                              }

                          case 3:
                            {
                              this.eventcollaboratorCollection = this.db.collection( event ).doc( this.eventcollaboratorcollectionName ).collection('collaborator', ref=>ref.
                                                                                                  where( 'sharecostparticipant' , 'array-contains-any' , [ eventorganiser[0], eventorganiser[1],  eventorganiser[2] ] )
                                                                                                );
                              break;
                            }

                          case 4:
                              {
                                this.eventcollaboratorCollection = this.db.collection( event ).doc( this.eventcollaboratorcollectionName ).collection('collaborator', ref=>ref.
                                                                                                    where( 'sharecostparticipant' , 'array-contains-any' , [ eventorganiser[0], eventorganiser[1],  eventorganiser[2], eventorganiser[3] ] )
                                                                                                  );
                                break;
                              }

                          case 5:
                            {
                              this.eventcollaboratorCollection = this.db.collection( event ).doc( this.eventcollaboratorcollectionName ).collection('collaborator', ref=>ref.
                                                                                                  where( 'sharecostparticipant' , 'array-contains-any' , [ eventorganiser[0], eventorganiser[1],  eventorganiser[2], eventorganiser[3], eventorganiser[4] ] )
                                                                                                );
                              break;
                            }

                        }

                    }
                                                                    
                  break;  
                }
          }
       
        this.eventcollaboratorItems = this.eventcollaboratorCollection.snapshotChanges().pipe
          ( map ( changes => 
                              {
                                return changes.map( 
                                                    a => {
                                                            const data  = a.payload.doc.data() as collaboratordetail;        
                                                            data.id     = a.payload.doc.id;
                                                            return data;    
                                                        }                            
                                                  )
                                }
                  )   
          );

      }
    //--------------------------------------------------------------
    // Account Profile       
    geteventcollaborator()
      {
          return this.eventcollaboratorItems;     
      }      
    //--------------------------------------------------------------
    async addUpdateCollaborator( addupdateid: number, eventid: string, collaboratordata: any, taskbudget: number )
      {

        const event  = 'event_' + eventid; 
        var successORFail: number;

        this.eventcollaboratorCRUDCollection = this.db.collection( event ).doc( this.eventcollaboratorcollectionName ).collection('collaborator');
      
        switch ( addupdateid )
          {
            //--------------------------------------------------------------
            // Add Collaborator
            case 10:
                {
                  
                  return successORFail = await this.eventcollaboratorCRUDCollection.doc( collaboratordata.id ).set
                            (
                                {
                                  id: collaboratordata.id,
                                  category: collaboratordata.category,
                                  providername: collaboratordata.providername,
                                  street: collaboratordata.street,
                                  suburb: collaboratordata.suburb,
                                  state: collaboratordata.state,
                                  postcode: collaboratordata.postcode,
                                  phone: collaboratordata.phone,
                                  mobile: collaboratordata.mobile,
                                  email: collaboratordata.email,
                                  contactperson: collaboratordata.contactperson,
                          
                                  statuslist: collaboratordata.statuslist,   // Three conditions 0=Listed, 5=Shortlist, 10=Confirm
                          
                                  amount: collaboratordata.amount,
                                  budget: collaboratordata.budget,

                                  notes: collaboratordata.notes,

                                  sharecoststring: '',
                                  sharecost: [],                            // List of Organiser Collaboartors Profile
                                  sharecostparticipant: [],
                          
                                  parenttaskid: collaboratordata.parenttaskid,
                                  ganttId: collaboratordata.ganttId,             // Gantt - id

                                  triggerrefresh: ''
                                  
                                },
                                { merge: true }
                            ).then( 
                                    () =>  {
                                              return  1;
                                            }
                                  ).catch ( () =>
                                                  { 
                                                    return 0;
                                                  }
                                          );
                                          
                  break;
                                          
                }
            //--------------------------------------------------------------    
            // Edit Collaborator
            case 20:
                {

                  return successORFail = await this.eventcollaboratorCRUDCollection.doc( collaboratordata.id ).update
                    (
                        {
                          providername: collaboratordata.providername,
                          category: collaboratordata.category,
                          street: collaboratordata.street,
                          suburb: collaboratordata.suburb,
                          state: collaboratordata.state,
                          postcode: collaboratordata.postcode,
                          phone: collaboratordata.phone,
                          mobile: collaboratordata.mobile,
                          email: collaboratordata.email,
                          contactperson: collaboratordata.contactperson,
                  
                          statuslist: collaboratordata.statuslist,   // Three conditions 0=Listed, 5=Shortlist, 10=Confirm
                  
                          amount: collaboratordata.amount,
                         // budget: taskbudget,
                          budget: collaboratordata.budget,

                          notes: collaboratordata.notes,
                        }
                    ).then( 
                            () =>  {
                                      return  1;
                                    }
                          ).catch ( () =>
                                          { 
                                            return 0;
                                          }
                                  );

                    break;

                    
                  }
              //--------------------------------------------------------------
              // Reset Event Organiser Cost to 0 due to a status reset from Confirm to Listed / Shortlist
              case 30:
                  {
                    var selsharecost: [];
                    var newsharecost1: Array<string> = []
                    var splitarray: Array<string> = [];
                    var selcost1: string;
                    var selcost2: string = '';

                    selsharecost = collaboratordata.sharecost;

                    if ( selsharecost.length > 0 )
                      {
                        //console.log( selsharecost )

                        for ( let i = 0; i <= selsharecost.length-1; i++ )
                          { 
                            selcost1     = selsharecost[i];

                            splitarray  = selcost1.split("#");

                            selcost1     = splitarray[0] + '#' + 
                                          '0'           + '#' + 
                                          splitarray[2] + '#' +
                                          splitarray[3] + '#' + 
                                          splitarray[0] + 'O' 

                            newsharecost1.push( selcost1 )

                            selcost2     = selcost2 + splitarray[0] + '#' + 
                                                      '0'           + '#' + 
                                                      splitarray[2] + '#' +
                                                      splitarray[3] + ','
                          }
                        
                          //console.log( newsharecost1 )
                          selcost2  = selcost2.substring(0, selcost2.length - 1)

                          return successORFail = await this.eventcollaboratorCRUDCollection.doc( collaboratordata.id ).update
                          (
                              {
                                sharecost: newsharecost1 ,    
                                sharecoststring: selcost2,
                                sharecostparticipant: []
                              }
                          ).then( () =>  {
                                            return  1;
                                          }
                                ).catch ( () =>
                                                { 
                                                  return 0;
                                                }
                                        );

                      }

                     break;

                  }
              //--------------------------------------------------------------
              case 40:
                  {
                    var selsharecost: [];
                    var newsharecost1: Array<string> = []
                    var splitarray: Array<string> = [];
                    var selcost1: string;
                    var selcost2: string = '';


                    return successORFail = await this.eventcollaboratorCRUDCollection.doc( collaboratordata.id ).update
                          (
                              {
                                sharecost: newsharecost1 ,    
                                sharecoststring: selcost2,
                                sharecostparticipant: []
                              }
                          ).then( 
                                  () =>  {
                                            return  1;
                                          }
                                ).catch ( () =>
                                                { 
                                                  return 0;
                                                }
                                        );
                    
                    break;

                  }
              //--------------------------------------------------------------

          }

          return -1

      }
    //--------------------------------------------------------------
    async cntcolloboratorconfirm(  eventid: string, selganttid: string ): Promise<number>
      {
        const event  = 'event_' + eventid; 
  
        let qry1 = await this.db.collection(event).doc( this.eventcollaboratorcollectionName).collection('collaborator').ref
                                                    .where( 'ganttId','==', selganttid )
                                                    .where( 'statuslist', '==', 'Confirm').get();

        return qry1.size

      }
    //**************************************************************
    // Collection - giftthankyou list
    // Load Collection - Observable
    //--------------------------------------------------------------  
    async crudeventgiftthankyou( eventid: string )
      {
        var successORFail: number;

        const event = 'event_' + eventid; 

        let thankyouid    = this.appfunction.createuniqueid(4)
        
        const inviteelist = [];
        inviteelist.push('Thankyou Id:'+thankyouid);
        
        this.eventgiftthankyouCRUDCollection = this.db.collection( event ).doc( this.eventgiftlistcollectionName ).collection('giftthankyou');

        return successORFail = await this.eventgiftthankyouCRUDCollection.doc( thankyouid ).set
                  (
                      {
                        id:               thankyouid,
                        deliverylist:     'TBC',            // Where will be the Gift Thankyou Note be delivered i.e. by email, post
                        giftrecieved:     'TBC',            // What was the gift received
                        giftlistlinkid:   '',
                        inviteename:       inviteelist
                       
                      },
                      { merge: true }
                  ).then( 
                          () =>  {
                                    return  1;
                                  }
                        ).catch ( () =>
                                        { 
                                          return 0;
                                        }
                                )    
      }
    //--------------------------------------------------------------
    loadgiftthakyoucard( eventid: string )
      {
        const event = 'event_' + eventid; 
      
        this.eventgiftthankyouCollection = this.db.collection( event ).doc( this.eventgiftlistcollectionName ).collection('giftthankyou');

        this.eventgiftthankyouItems = this.eventgiftthankyouCollection.snapshotChanges().pipe
          ( map ( changes => 
                              {
                                return changes.map( 
                                                    a => {
                                                            const data  = a.payload.doc.data() as gifthankyou;        
                                                            data.id     = a.payload.doc.id;
                                                            return data;    
                                                        }                            
                                                  )
                                }
                  )   
          )

      }

    // Get table seat list for invitees
    geteventtgiftthankyoucardlist()
      {
          return this.eventgiftthankyouItems;     
      } 
    //--------------------------------------------------------------
    //**************************************************************
    async addDashboardInviteeStats( eventid: string, id : string  )
      {
        var successORFail: number;

        const event = 'event_' + eventid; 

        this.eventinviteedashboardCRUDCollection = this.db.collection( event ).doc( this.eventdashboardcollectionName ).collection('invitee');

        return successORFail = await this.eventinviteedashboardCRUDCollection.doc( id ).set
          (
            {
              id: id,
              totalinvite:    0,          // Total Guest Invited
              totalcoming:    0,          // Total Guest Coming
              totalundecided: 0,          // Total Guest undecided 
              totalconfirm:   0,          // Total Guest Confirmed
              totalnotcoming: 0,          // Total Guest not coming
              totaldietary:   0,          // Total Guest that has dietary requirements
              totalseat:      0,          // Total thats been allocated a seat
              totalgiftthankyou: 0
            },
            { merge: true }
          ).then( 
                  () =>   {
                            return  1;
                          }
                ).catch ( () => { 
                                  return 0;
                                }
                        )    
    }
    //**************************************************************
    async addDashboardFinanceStats( eventid: string, id : string  )
      {
        var successORFail: number;

        const event = 'event_' + eventid; 

        this.eventfinancedashboardCRUDCollection = this.db.collection( event ).doc( this.eventdashboardcollectionName ).collection('finance');

        return successORFail = await this.eventfinancedashboardCRUDCollection.doc( id ).set
          (
            {
              id: id,
              totalactualcost:       0,       // Total Actual Cost of Event Shared %
              totalbudgetcost:       0,       // Total Budget Cost of Event Shared %
              totalABSactualcost:    0,       // 
              totalABSbudgetcost:    0,       // 
              totalbudget:           0        // Total Budget Cost of Event from Participant Profile
             
            },
            { merge: true }
          ).then( 
                  () =>   {
                            return  1;
                          }
                ).catch ( () => { 
                                  return 0;
                                }
                        )    
    }
    //**************************************************************
    async addDashboardAppointmentStats( eventid: string, id : string  )
      {
        var successORFail: number;

        const event = 'event_' + eventid; 

        
        var defaultdate: Date = new Date // current system date

        let defaultdateformat  = formatDate( defaultdate, 'yyyy-MM-ddTHH:mm:ss', 'en' );

        this.eventappointmentdashboardCRUDCollection = this.db.collection( event ).doc( this.eventdashboardcollectionName ).collection('appointments');

        return successORFail = await this.eventappointmentdashboardCRUDCollection.doc( id ).set
          (
            {
              id: id,

              reportdate:           defaultdate,         // reportdate when the add/delete/update change in eventscheduler/schedulertask
              reportdatestring:     defaultdateformat,
          
              startDate:            defaultdate,         // startdate of filter
              startDatestring:      defaultdateformat,

              endDate:              defaultdate,         // enddate of filter
              endDatestring:        defaultdateformat,

              totalnoappointments:   0         // Total No of Appointments
            },
            { merge: true }
          ).then( 
                  () =>   {
                            return  1;
                          }
                ).catch ( () => { 
                                  return 0;
                                }
                        )    
    }
    //**************************************************************
    async addDashboardGanttStats( eventid: string, id : string  )
      {
        var successORFail: number;

        const event = 'event_' + eventid; 

        var defaultdate: Date = new Date // current system date

        let defaultdateformat  = formatDate( defaultdate, 'yyyy-MM-ddTHH:mm:ss', 'en' );

        this.eventganttdashboardCRUDCollection = this.db.collection( event ).doc( this.eventdashboardcollectionName ).collection('gantttasks');

        return successORFail = await this.eventganttdashboardCRUDCollection.doc( id ).set
          (
            {
              id: id,
              reportdate:       defaultdate,         // reportdate when the add/delete/update change in eventtaskgantt/gantttask
              reportdatestring: defaultdateformat, 
              totalnotask:   0         // Total No of Appointments
            },
            { merge: true }
          ).then( 
                  () =>   {
                            return  1;
                          }
                ).catch ( () => { 
                                  return 0;
                                }
                        )    
    }
    //**************************************************************
    // Dashboards
    // Invitee
    loadeventdashboardInvitee( eventid: string, organiserid: string )
              {
                const event = 'event_' + eventid; 

                this.eventinviteedashboardCollection = this.db.collection( event ).doc( this.eventdashboardcollectionName ).collection('invitee', ref=>ref.
                                                                                                                            where( 'id' , '==' , organiserid )
                                                                                                                          );

                this.eventinviteedashboardItems = this.eventinviteedashboardCollection.snapshotChanges().pipe
                  ( map ( changes => 
                                      {
                                        return changes.map( 
                                                            a => {
                                                                    const data  = a.payload.doc.data() as inviteedashboard;        
                                                                    data.id     = a.payload.doc.id;
                                                                    return data;    
                                                                }                            
                                                          )
                                        }
                          )   
                  )

              }
            //--------------------------------------------------------------
            // Account Profile       
            geteventdashboardorganiser()
              {
                  return this.eventinviteedashboardItems;     
              }      
            //--------------------------------------------------------------


    //**************************************************************
    getlistinginvitee( eventid: string, seloption: number, selid: string ): Observable< Array<dashboardinviteelist> >
    {
      
       // var subject = new Subject<string>();
        var subject = new Subject< Array<dashboardinviteelist> >()

        //   switch ( seloption )
        const event = 'event_' + eventid; 

        var title: string;
        var inviteelist: string[] = [];
        var selinviteelist: string[] = [];


      
        var returninviteelist: Array<dashboardinviteelist> = []; // Empty Array

      
        this.db.collection( event ).doc( 'eventinvitationlist' ).collection('invitationlist').doc( selid ).
          get().subscribe( ref => {

                                    if ( ref.exists)
                                      {
                                        title       = ref.data()['delivery'];
                                        inviteelist = ref.data()['inviteename'];
                                        //   console.log( inviteelist )

                                        for (let i = 0; i < inviteelist.length; i++) 
                                          {
                                           // console.log( i + '-' +  inviteelist[i])

                                            if ( i != 0 )
                                              {
                                                selinviteelist.push
                                                  (
                                                    inviteelist[i]
                                                  );
                                              }

                                          }

                                        returninviteelist.push
                                          (
                                            {
                                              title: title,
                                              inviteename: selinviteelist 
                                            }
                                          );

                                       // subject.next( title );

                                       subject.next( returninviteelist );

                                      }

                                     
                                   }
                          )

        return subject.asObservable(); 
                    
      
    }
    //**************************************************************
    // Dashboards
    // Finance
    loadeventdashboardFinance( eventid: string, organiserid: string )
              {
                const event = 'event_' + eventid; 

                this.eventfinancedashboardCollection = this.db.collection( event ).doc( this.eventdashboardcollectionName ).collection('finance', ref=>ref.
                                                                                                                            where( 'id' , '==' , organiserid )
                                                                                                                          );

                this.eventfinancedashboardItems = this.eventfinancedashboardCollection.snapshotChanges().pipe
                  ( map ( changes => 
                                      {
                                        return changes.map( 
                                                            a => {
                                                                    const data  = a.payload.doc.data() as financedashboard;        
                                                                    data.id     = a.payload.doc.id;
                                                                    return data;    
                                                                }                            
                                                          )
                                        }
                          )   
                  )

              }
    //--------------------------------------------------------------
    // Account Profile       
    geteventdashboardfinance()
      {
          return this.eventfinancedashboardItems;     
      }      
    //--------------------------------------------------------------
    //**************************************************************
    // Finance Category
    loadeventdashboardFinancecategory( eventid: string, category: string )
              {
                const event = 'event_' + eventid; 

                if ( category.length > 0 )
                  {

                    this.eventfinancecategorydashboardCollection = this.db.collection( event ).doc( this.eventdashboardcollectionName ).collection('financecategory', ref=>ref.
                                                                                                                                        where( 'category' , '==' , category )
                                                                                                                                      );
                  }
                else
                  {
                  
                    this.eventfinancecategorydashboardCollection = this.db.collection( event ).doc( this.eventdashboardcollectionName ).collection('financecategory',ref=>ref.
                                                                                                                                                    orderBy('category','asc')
                                                                                                                                                  )
                  }

                this.eventfinancecategorydashboardItems = this.eventfinancecategorydashboardCollection.snapshotChanges().pipe
                  ( map ( changes => 
                                      {
                                        return changes.map( 
                                                            a => {
                                                                    const data  = a.payload.doc.data() as financecategory;        
                                                                    data.id     = a.payload.doc.id;
                                                                    return data;    
                                                                }                            
                                                          )
                                        }
                          )   
                  )

              }
    //--------------------------------------------------------------
    // Finance Category Profile       
    geteventdashboardfinancecateory()
      {
          return this.eventfinancecategorydashboardItems;     
      }      
    //--------------------------------------------------------------
    //**************************************************************
    // Finance Category
    loadeventFinancecategory( eventid: string, )
     {
        const event = 'event_' + eventid; 
         
        this.eventfinancecategoryCollection = this.db.collection( event ).doc( this.eventdashboardcollectionName ).collection('financecategorylist',ref=>ref.
                                                                                                                                           orderBy('category','asc')
                                                                                                                                         )
       this.eventfinancecategoryItems = this.eventfinancecategoryCollection.snapshotChanges().pipe
         ( map ( changes => 
                             {
                               return changes.map( 
                                                   a => {
                                                           const data         = a.payload.doc.data() as financecategorylist;        
                                                           data.id            = a.payload.doc.id;
                                                           return data;    
                                                       }                            
                                                 )
                               }
                 )   
         )

     }
//--------------------------------------------------------------
// Finance Category Profile       
geteventfinancecateory()
  {
  return this.eventfinancecategoryItems;     
  }      
//--------------------------------------------------------------
//**************************************************************
    async countappointment_for_period(  eventid: string, orderid: number, startdate: Date, endate: Date ): Promise<number>
      {
        const event  = 'event_' + eventid; 

        var nocnt: number;

        let startD  = formatDate( startdate, 'yyyy-MM-ddTHH:mm:ss', 'en' );
        let endD    = formatDate( endate, 'yyyy-MM-ddTHH:mm:ss', 'en' );

        
        if ( orderid == -1 )
          {
            let qry1 = await this.db.collection(event).doc( this.eventschedulercollectionName).collection('schedulertask').ref
                                                        .where( 'sdate', '<=', endate ).get();

            nocnt =  qry1.size 
          }

        if ( orderid == 0 )
            {

             // console.log( startdate )
              //console.log( endate )
              let qry1 = await this.db.collection(event).doc( this.eventschedulercollectionName).collection('schedulertask').ref
                                                          .where( 'sdate', '>=', startdate )
                                                          .where( 'sdate', '<=', endate )
                                                          .get();
  
              nocnt =  qry1.size 
            }


                

        if ( orderid !== -1 )
          {
            let qry1 = await this.db.collection(event).doc( this.eventschedulercollectionName).collection('schedulertask').ref
                                                        .where( 'startDate','>=', startD )
                                                        .where( 'startDate', '<=', endD ).get();

            nocnt =  qry1.size
          }

        if ( orderid == -99 )
          {

            let qry1 = await this.db.collection(event).doc( this.eventschedulercollectionName).collection('schedulertask').ref
                                                        .where( 'startDate', '>=', startD ).get();

            nocnt =  qry1.size
          }
                

      return  nocnt 

       

      }
    //**************************************************************
    async isAdminSignInValid( selcollectionid: string, selpassword: string )
    {

        const pathdataDest = this.admincollectionName;

        let qry1 = await this.db.collection(pathdataDest).ref.where( 'email','==', selcollectionid )
                                                                     .where( 'password', '==', selpassword).get();
        // Create Empty Array
        this.loginprofile = []

        if ( qry1.size == 1 )      
          {
              
            qry1.forEach  ( doc =>
                            {
                                this.loginprofile.push(   {
                                                            recsize: qry1.size,
                                                            eventid: doc.get('eventid'),
                                                            stripestatus: false                               
                                                          }
                                                      );

                            }
                          );

            return this.loginprofile;  
                             
          }                                                       
        else
          {

            this.loginprofile.push(   {
                                        recsize: qry1.size,
                                        eventid: 'TBC',
                                        stripestatus: false          
                                      }
                                  );

            return this.loginprofile;                            

            
          }
    }
    //**************************************************************
    loadadminfaqcategory()
        {

            // Property->Document->Service Providers Profile
            this.adminfaqcatDocCollection = this.db.collection( this.faqcollectionName ),ref=>ref.orderBy('id','asc');
                                                                
            this.adminfaqcatDocItems = this.adminfaqcatDocCollection.snapshotChanges().pipe
            ( map ( changes => 
                        {
                        return changes.map  ( 
                                        a => {
                                                const data   = a.payload.doc.data() as faqcategory;        
                                                data.id      = a.payload.doc.id;
                                                return data;    
                                            }                            
                                    )
                        }
                    )   
            )  

        }
    //**************************************************************
    getfaqcategory()
        {
            return this.adminfaqcatDocItems;     
        }   
    //**************************************************************
    // Update Document Owner Details
    async updatefaqnote( 
                            faqnotekey: string,
                            faqcat: string,
                            faqid: string,
                            event: any  
                        )
        {
    
            this.faqDocCRUDCollection =  this.db.collection( this.faqnotecollectionName );

            await this.faqDocCRUDCollection.doc(faqnotekey).set    
                (
                    {   id:faqnotekey,
                        notecat: faqcat,
                        sortid: event.data.sortid,
                        noteid: event.data.noteid,
                        title: event.data.title,
                        note: event.data.note,
                        notestatus: event.data.notestatus
                    },
                    { merge: true }
                );   
                        
        }
    //**************************************************************
    async getfaqdocmaxid( selfaqdocid: string )
        {
            const pathdataDest = this.faqnotecollectionName;

            let qry1 = await this.db.collection(pathdataDest).ref.where( 'notecat', '==', selfaqdocid).
                                                        where( 'notestatus' ,  '==' , true ).
                                                        orderBy('noteid', 'desc').limit(1).
                                                        get();
                                                        
            if ( qry1.size == 0 ) 
                {
                    return 100   
                }
            else
                { 

                    var maxfaqid: number;

                    qry1.forEach( doc =>
                        {
                            maxfaqid = Number( doc.get('noteid') ) + 10; 

                        }
                    );

                    return maxfaqid;
                }
        }   
    //**************************************************************
    loadfaqdocument( faqid: string )
      {
          // Property->Document->Service Providers Profile
          this.faqDocCollection = this.db.collection( this.faqnotecollectionName,ref=>ref.
                                                          where( 'notecat', '==' , faqid).
                                                          where( 'notestatus', '==', true).
                                                          orderBy('sortid','asc').
                                                          orderBy('noteid','asc')
                                                      );
                                                              

          this.faqDocItems = this.faqDocCollection.snapshotChanges().pipe
          ( map ( changes => 
                      {
                      return changes.map  ( 
                                      a => {
                                              const data   = a.payload.doc.data() as faqdetail;        
                                              data.id      = a.payload.doc.id;
                                              return data;    
                                          }                            
                                  )
                      }
                  )   
          )  

      }
//**************************************************************
// Organiser->Property-Confirm Service Providers
getfaqdocument()
  {
      return this.faqDocItems;     
  }   
//**************************************************************
  }
